(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5944],{

/***/ 75563:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-account/[...slug]",
      function () {
        return __webpack_require__(71167);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 41534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_MyGenericFiller; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/Shared/OrderHistory/v1/OrderProgressiveLoading.jsx
var OrderProgressiveLoading = __webpack_require__(10030);
// EXTERNAL MODULE: ./components/core/PageLoader/PageLoader.jsx + 1 modules
var PageLoader = __webpack_require__(41600);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./components/AccountsLayout/AccountsLayout/index.jsx
var AccountsLayout = __webpack_require__(96655);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(24400);
;// CONCATENATED MODULE: ./i18n/useGeneric.js

const useGeneric = (param)=>{
    let { componentProps: { headLine  } = {}  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const i18n = {
        myAccount: t("kf.account.label.myAccount"),
        myServices: t("kf.account.label.myServices"),
        favoriteTitle: t("kf.favorite.label.favoriteTitle"),
        listTitle: t("kf.account.label.myLists"),
        orders: t("kf.account.label.orders"),
        myProducts: headLine !== null && headLine !== void 0 ? headLine : t("kf.myProducts.label.myProducts"),
        hi: t("kf.account.label.hi"),
        accountSettings: t("kf.account.label.accountSettings")
    };
    return i18n;
};
/* harmony default export */ var i18n_useGeneric = (useGeneric);

;// CONCATENATED MODULE: ./components/MyGenericFiller.jsx








const MyGenericFiller = (param)=>{
    let { data: componentProps , title  } = param;
    const staticTexts = i18n_useGeneric({
        componentProps
    });
    const { featureFlags ={}  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { MYSQLCONNSTR_ENABLE_SHOPPING_LISTS_V2: isSaveProductToList = false  } = featureFlags;
    (0,react.useEffect)(()=>{
        window.scrollTo({
            top: 1,
            behavior: "smooth"
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AccountsLayout/* default */.Z, {
        title: isSaveProductToList && title === "favoriteTitle" ? staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.listTitle : staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts[title],
        staticTexts: staticTexts,
        i18n: staticTexts,
        accountLayoutLoader: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLoader/* default */.Z, {
                loading: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderProgressiveLoading/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var components_MyGenericFiller = (MyGenericFiller);


/***/ }),

/***/ 48375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9473);
/* harmony import */ var _store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24899);
/* harmony import */ var _store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46201);
/* harmony import */ var _hooks_usePrevious__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67166);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55760);
/* harmony import */ var _utils_cart__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11763);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2595);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19514);









const usePageAuth = ()=>{
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    const { access_token: accessToken  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__/* .selectAuthState */ ._9);
    const { cart: activeCart , isCartLoading  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .selectCartState */ .xw);
    const prevToken = (0,_hooks_usePrevious__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        accessToken
    });
    // just for the dev testing purpose, if works fine then can only be proceed otherwise
    // one more pr will be raised to revert the change
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        let timeoutId;
        if (!isSsr) {
            timeoutId = setTimeout(()=>{
                if (!accessToken || !(0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .isGuestTokenValid */ .DVc)()) {
                    dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_2__/* .getOktaToken */ .cs)("guest"));
                }
            }, 5000);
        }
        ;
        ()=>{
            clearTimeout(timeoutId);
        };
    }, [
        accessToken,
        isSsr
    ]);
    const callInitAuth = async ()=>{
        var ref;
        const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_8__/* .getConfig */ .i)();
        const disableCommerce = (config === null || config === void 0 ? void 0 : (ref = config.general) === null || ref === void 0 ? void 0 : ref.disableCommerce) || false;
        if (disableCommerce) return;
        const hasNoActiveCart = ()=>{
            return (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .isGuestTokenValid */ .DVc)() && accessToken && !(activeCart === null || activeCart === void 0 ? void 0 : activeCart.id) && !(activeCart === null || activeCart === void 0 ? void 0 : activeCart.cartExists);
        };
        if (hasNoActiveCart() || hasNoActiveCart() && (prevToken === null || prevToken === void 0 ? void 0 : prevToken.accessToken) !== accessToken) {
            if (!isCartLoading) {
                dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .setCardStatus */ .YZ)(true));
                dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .getCart */ .dv)()).unwrap().then((res)=>{
                    if ((0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .isGuestTokenValid */ .DVc)() && accessToken && (res === null || res === void 0 ? void 0 : res.cartExists) && (res === null || res === void 0 ? void 0 : res.cartExists) === "false" && (res === null || res === void 0 ? void 0 : res.error) === "No active cart exists.") {
                        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .getCurrency */ .zC$)().then((currency)=>{
                            const cartPayload = {
                                currency: currency,
                                taxMode: "ExternalAmount"
                            };
                            dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .createCart */ .Bk)(cartPayload)).unwrap().then(()=>{
                                dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .setCardStatus */ .YZ)(false));
                            });
                        });
                    } else {
                        dispatch((0,_store_features_cartSlice__WEBPACK_IMPORTED_MODULE_3__/* .setCardStatus */ .YZ)(false));
                    }
                });
            }
        }
        (0,_utils_cart__WEBPACK_IMPORTED_MODULE_6__/* .setCartLandingPagePath */ .NS)();
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (isSsr) return;
        callInitAuth();
    }, [
        accessToken,
        isSsr
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (usePageAuth);


/***/ }),

/***/ 71167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(24400);
;// CONCATENATED MODULE: ./i18n/useMyfavoritesi18n.js

const useMyFavoritesi18n = (param)=>{
    let { componentProps , selectedItems , isSaveProductToList  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const i18n = {
        favoriteTitle: isSaveProductToList ? t("kf.account.label.myLists") : t("kf.favorite.label.favoriteTitle"),
        accountSettings: t("kf.account.label.accountSettings"),
        favorites: isSaveProductToList ? t("kf.account.label.myLists") : t("kf.account.label.favorites"),
        myLists: t("kf.account.label.myLists"),
        createNewList: t("kf.saveToList.create.header"),
        media: t("kf.account.label.media"),
        lists: t("kf.account.label.lists"),
        orders: t("kf.account.label.orders"),
        myProducts: t("kf.account.label.myProducts"),
        myServices: t("kf.account.label.myServices"),
        myAccount: t("kf.account.label.myAccount"),
        hi: t("kf.account.label.hi"),
        signOut: t("kf.account.label.signOut"),
        myFavorites: t("kf.favorite.label.myFavorites"),
        allTab: t("kf.favorite.label.allTab"),
        productsTab: t("kf.favorite.label.productsTab"),
        imagesTab: t("kf.favorite.label.imagesTab"),
        newToOld: t("kf.favorites.sort.newToOld"),
        oldToNew: t("kf.favorites.sort.oldToNew"),
        videosTab: t("kf.favorite.label.videosTab"),
        articlesTab: t("kf.favorite.label.articlesTab"),
        manageText: t("kf.favorite.label.manageText"),
        sort: t("kf.favorite.label.sort"),
        sortbyExpanded: t("kf.plp.label.sortbyExpanded"),
        sortbyClosed: t("kf.plp.label.sortbyClosed"),
        selected: t("kf.plp.arialabel.selected"),
        altSort: t("kf.plp.label.img.altSort"),
        loadMore: t("kf.favorite.label.loadMore"),
        backToTop: t("kf.favorite.label.backToTop"),
        favoriteDeleteTitle: t("kf.favorite.label.favoriteDeleteTitle"),
        favoritesDeleteMssg: t("kf.favorite.label.favoritesDeleteMssg", {
            count: selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.length
        }),
        manageFavorites: t("kf.favorite.label.manageFavorites"),
        selectAll: t("kf.favorite.label.selectAll"),
        UnselectAll: t("kf.favorite.label.UnselectAll"),
        cancel: t("kf.favorite.label.cancel"),
        remove: t("kf.favorite.label.remove"),
        itemCancel: t("kf.favorite.label.itemCancel"),
        itemRemove: t("kf.favorite.label.itemRemove"),
        removeItem: t("kf.favorites.removeItem"),
        continueShopping: (componentProps === null || componentProps === void 0 ? void 0 : componentProps.continueShoppingText) ? componentProps === null || componentProps === void 0 ? void 0 : componentProps.continueShoppingText : t("kf.favorites.label.continueShopping"),
        addToYourFavorites: t("kf.favorites.label.addToYourFavorites"),
        addToCompare: t("kf.plp.label.addToCompare"),
        colors: t("kf.plp.label.colors"),
        color: t("kf.plp.label.color"),
        startingAt: t("kf.plp.label.startingAt"),
        new: t("kf.plp.label.new"),
        sale: t("kf.plp.label.sale"),
        view: t("kf.plp.label.view"),
        items: t("kf.plp.label.items"),
        all: t("kf.plp.label.all"),
        exclusive: t("kf.plp.label.exclusive"),
        newExclusive: t("kf.plp.label.newExclusive"),
        sortByAria: (count)=>t("kf.plp.label.sortByAria", {
                sortByCount: count
            }),
        ariaLabel: {
            tabs: (count, tabName)=>t("kf.favorite.aria.label.tabs", {
                    count,
                    tabName
                }),
            allTab: t("kf.favorite.aria.label.allTab"),
            close: t("kf.findStoreUtilNav.label.closeAlt"),
            manageSelected: (count)=>t("kf.favorite.aria.label.manageSelected", {
                    count
                }),
            remove: t("kf.favorite.label.aria.remove", {
                count: selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.length
            }),
            selectedAll: t("kf.favorite.aria.label.selectedAll"),
            favoriteRemoved: t("kf.favorites.removed"),
            hi: t("kf.account.label.hi")
        },
        availableIn: t("kf.account.label.availableIn"),
        colorOrFinish: t("kf.pdp.label.colorOrFinish"),
        skuItem: t("kf.cart.label.sku")
    };
    return i18n;
};
/* harmony default export */ var useMyfavoritesi18n = (useMyFavoritesi18n);

// EXTERNAL MODULE: ./store/features/favoritesSlice.js + 1 modules
var favoritesSlice = __webpack_require__(7737);
// EXTERNAL MODULE: ./store/features/authSlice.js
var authSlice = __webpack_require__(24899);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./utils/orders.js
var orders = __webpack_require__(79540);
// EXTERNAL MODULE: ./utils/location.js
var utils_location = __webpack_require__(97433);
// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__(20558);
// EXTERNAL MODULE: ./constants/config.js
var constants_config = __webpack_require__(19514);
// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(96301);
;// CONCATENATED MODULE: ./node_modules/react-masonry-css/dist/react-masonry-css.module.js


function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
const defaultProps = {
  breakpointCols: undefined,
  // optional, number or object { default: number, [key: number]: number }
  className: undefined,
  // required, string
  columnClassName: undefined,
  // optional, string
  // Any React children. Typically an array of JSX items
  children: undefined,
  // Custom attributes, however it is advised against
  // using these to prevent unintended issues and future conflicts
  // ...any other attribute, will be added to the container
  columnAttrs: undefined,
  // object, added to the columns
  // Deprecated props
  // The column property is deprecated.
  // It is an alias of the `columnAttrs` property
  column: undefined
};
const DEFAULT_COLUMNS = 2;

class Masonry extends react.Component {
  constructor(props) {
    super(props); // Correct scope for when methods are accessed externally

    this.reCalculateColumnCount = this.reCalculateColumnCount.bind(this);
    this.reCalculateColumnCountDebounce = this.reCalculateColumnCountDebounce.bind(this); // default state

    let columnCount;

    if (this.props.breakpointCols && this.props.breakpointCols.default) {
      columnCount = this.props.breakpointCols.default;
    } else {
      columnCount = parseInt(this.props.breakpointCols) || DEFAULT_COLUMNS;
    }

    this.state = {
      columnCount
    };
  }

  componentDidMount() {
    this.reCalculateColumnCount(); // window may not be available in some environments

    if (window) {
      window.addEventListener('resize', this.reCalculateColumnCountDebounce);
    }
  }

  componentDidUpdate() {
    this.reCalculateColumnCount();
  }

  componentWillUnmount() {
    if (window) {
      window.removeEventListener('resize', this.reCalculateColumnCountDebounce);
    }
  }

  reCalculateColumnCountDebounce() {
    if (!window || !window.requestAnimationFrame) {
      // IE10+
      this.reCalculateColumnCount();
      return;
    }

    if (window.cancelAnimationFrame) {
      // IE10+
      window.cancelAnimationFrame(this._lastRecalculateAnimationFrame);
    }

    this._lastRecalculateAnimationFrame = window.requestAnimationFrame(() => {
      this.reCalculateColumnCount();
    });
  }

  reCalculateColumnCount() {
    const windowWidth = window && window.innerWidth || Infinity;
    let breakpointColsObject = this.props.breakpointCols; // Allow passing a single number to `breakpointCols` instead of an object

    if (typeof breakpointColsObject !== 'object') {
      breakpointColsObject = {
        default: parseInt(breakpointColsObject) || DEFAULT_COLUMNS
      };
    }

    let matchedBreakpoint = Infinity;
    let columns = breakpointColsObject.default || DEFAULT_COLUMNS;

    for (let breakpoint in breakpointColsObject) {
      const optBreakpoint = parseInt(breakpoint);
      const isCurrentBreakpoint = optBreakpoint > 0 && windowWidth <= optBreakpoint;

      if (isCurrentBreakpoint && optBreakpoint < matchedBreakpoint) {
        matchedBreakpoint = optBreakpoint;
        columns = breakpointColsObject[breakpoint];
      }
    }

    columns = Math.max(1, parseInt(columns) || 1);

    if (this.state.columnCount !== columns) {
      this.setState({
        columnCount: columns
      });
    }
  }

  itemsInColumns() {
    const currentColumnCount = this.state.columnCount;
    const itemsInColumns = new Array(currentColumnCount); // Force children to be handled as an array

    const items = react.Children.toArray(this.props.children);

    for (let i = 0; i < items.length; i++) {
      const columnIndex = i % currentColumnCount;

      if (!itemsInColumns[columnIndex]) {
        itemsInColumns[columnIndex] = [];
      }

      itemsInColumns[columnIndex].push(items[i]);
    }

    return itemsInColumns;
  }

  renderColumns() {
    const {
      column,
      columnAttrs = {},
      columnClassName
    } = this.props;
    const childrenInColumns = this.itemsInColumns();
    const columnWidth = `${100 / childrenInColumns.length}%`;
    let className = columnClassName;

    if (className && typeof className !== 'string') {
      this.logDeprecated('The property "columnClassName" requires a string'); // This is a deprecated default and will be removed soon.

      if (typeof className === 'undefined') {
        className = 'my-masonry-grid_column';
      }
    }

    const columnAttributes = _objectSpread(_objectSpread(_objectSpread({}, column), columnAttrs), {}, {
      style: _objectSpread(_objectSpread({}, columnAttrs.style), {}, {
        width: columnWidth
      }),
      className
    });

    return childrenInColumns.map((items, i) => {
      return /*#__PURE__*/react.createElement("div", _extends({}, columnAttributes, {
        key: i
      }), items);
    });
  }

  logDeprecated(message) {
    console.error('[Masonry]', message);
  }

  render() {
    const _this$props = this.props,
          {
      // ignored
      children,
      breakpointCols,
      columnClassName,
      columnAttrs,
      column,
      // used
      className
    } = _this$props,
          rest = _objectWithoutProperties(_this$props, ["children", "breakpointCols", "columnClassName", "columnAttrs", "column", "className"]);

    let classNameOutput = className;

    if (typeof className !== 'string') {
      this.logDeprecated('The property "className" requires a string'); // This is a deprecated default and will be removed soon.

      if (typeof className === 'undefined') {
        classNameOutput = 'my-masonry-grid';
      }
    }

    return /*#__PURE__*/react.createElement("div", _extends({}, rest, {
      className: classNameOutput
    }), this.renderColumns());
  }

}

Masonry.defaultProps = defaultProps;

/* harmony default export */ var react_masonry_css_module = (Masonry);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-sticky-el/lib/index.js
var lib = __webpack_require__(75198);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./hooks/useSmartCrop.js
var useSmartCrop = __webpack_require__(83886);
// EXTERNAL MODULE: ./components/Shared/OrderHistory/v1/OrderProgressiveLoading.jsx
var OrderProgressiveLoading = __webpack_require__(10030);
// EXTERNAL MODULE: ./components/core/PageLoader/PageLoader.jsx + 1 modules
var PageLoader = __webpack_require__(41600);
// EXTERNAL MODULE: ./components/core/Modal/Modal.jsx + 1 modules
var Modal = __webpack_require__(78145);
// EXTERNAL MODULE: ./components/AccountsLayout/AccountsLayout/index.jsx
var AccountsLayout = __webpack_require__(96655);
// EXTERNAL MODULE: ./components/ProductList/v2/Sort/index.jsx + 2 modules
var Sort = __webpack_require__(75329);
// EXTERNAL MODULE: ./components/core/Button/Button.jsx + 1 modules
var Button = __webpack_require__(7872);
// EXTERNAL MODULE: ./components/ProductList/v2/ProductListView/ProductsPerPage/index.jsx
var ProductsPerPage = __webpack_require__(1306);
// EXTERNAL MODULE: ./public/icons/close.svg
var icons_close = __webpack_require__(653);
;// CONCATENATED MODULE: ./components/MyFavorites/v1/ImageTile.jsx




const ImageTile = (param)=>{
    let { altText ="" , url ="" , smartCrop ={}  } = param;
    const [showModal, setShowModal] = (0,react.useState)(false);
    const favImage = (0,react.useRef)(null);
    const imgPlaceholder = constants.imgPlaceholderData;
    const isScene7Img = url.includes("scene7");
    const openModal = ()=>{
        setShowModal(true);
        document.body.classList.add("modal-open");
    };
    const closeModal = ()=>{
        setShowModal(false);
        document.body.classList.remove("modal-open");
    };
    (0,react.useEffect)(()=>{
        if (smartCrop.scriptStatus && isScene7Img) {
            smartCrop.applySmartCrop(favImage.current);
        }
    }, [
        smartCrop.scriptStatus
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "image-tile",
                role: "link",
                tabIndex: "0",
                "aria-label": altText,
                children: isScene7Img ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    ref: favImage,
                    src: imgPlaceholder,
                    "data-src": url,
                    alt: altText,
                    onClick: ()=>openModal()
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: url,
                    alt: altText,
                    onClick: ()=>openModal()
                })
            }),
            showModal && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "favorites-lightbox",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "favorites-lightbox__modal",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "favorites-lightbox__close",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: icons_close/* default */.Z === null || icons_close/* default */.Z === void 0 ? void 0 : icons_close/* default.src */.Z.src,
                                alt: "close",
                                onClick: ()=>closeModal()
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "favorites-lightbox__modal__scroll",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: url,
                                alt: altText,
                                className: "favorites-lightbox__modal-img"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var v1_ImageTile = (ImageTile);

// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(57333);
// EXTERNAL MODULE: ./hooks/useWindowResize.js
var useWindowResize = __webpack_require__(11859);
// EXTERNAL MODULE: ./components/core/Highlight/Highlight.jsx
var Highlight = __webpack_require__(15540);
// EXTERNAL MODULE: ./components/SocialShare/v1/SocialShare.jsx + 3 modules
var SocialShare = __webpack_require__(49019);
// EXTERNAL MODULE: ./public/icons/share.svg
var share = __webpack_require__(66773);
// EXTERNAL MODULE: ./public/icons/wish.svg
var wish = __webpack_require__(29875);
// EXTERNAL MODULE: ./public/icons/wishlist-gray-filled.svg
var wishlist_gray_filled = __webpack_require__(62084);
;// CONCATENATED MODULE: ./components/ProductList/v1/ProductTile/index.jsx


















const ProductTile = (props)=>{
    var ref, ref1, ref2;
    const { data ={} , texts ={} , lite , loading =false , compareData ={} , highlightText ="" , currencySign ="" , isGrouped =false , rowCols , presetConfigs ="{}" , isPartsDiagramLinkVisible =false , isFavoriteVariant =false , isVariantSku ={}  } = props;
    const isFavoriteIsVariantSelected = isFavoriteVariant && isVariantSku.sku;
    const [isChecked, setIsChecked] = (0,react.useState)(false);
    const [showShare, setShowShare] = (0,react.useState)(false);
    const [onHover, setOnHover] = (0,react.useState)(false);
    var ref3;
    const sku = (ref3 = data["sku_s"]) !== null && ref3 !== void 0 ? ref3 : data["masterSKU_s"];
    const dispatch = (0,es/* useDispatch */.I0)();
    const persona = (0,helper/* getUserPersona */.shu)();
    const [width] = (0,useWindowResize/* default */.Z)();
    const cartData = (0,es/* useSelector */.v9)((state)=>state.cart.data);
    const { isAuth: isAuthenticated  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const [siteName, setSiteName] = (0,react.useState)();
    const [swatchUrlData, setSwatchUrlData] = (0,react.useState)();
    const [skuVariantPrice, setSkuVariantPrice] = (0,react.useState)();
    const [skuVariantPriceDiscount, setSkuVariantPriceDiscount] = (0,react.useState)(0);
    const [currencyCode, setCurrencyCode] = (0,react.useState)();
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>{
            const brandName = get_default()(config, "general.siteName");
            const { swatchUrl  } = get_default()(config, "general");
            const currencyCode = get_default()(config, "internationalization.currencyCode");
            setSiteName(brandName);
            setSwatchUrlData(swatchUrl);
            setCurrencyCode(currencyCode);
        });
    }, []);
    let images = [];
    let productVariantImages = data["productImages.labelWithUrl_ss"] ? data["productImages.labelWithUrl_ss"] : [];
    let setDefaultProductImage = "";
    let setHoverProductImage = "";
    let isHover = true;
    let variantImages = [];
    if ((productVariantImages === null || productVariantImages === void 0 ? void 0 : productVariantImages.length) > 0) {
        let productVariantImagesFav = [];
        if (isFavoriteIsVariantSelected) {
            const foundImages = productVariantImages.find((item)=>item.split("|")[0] === isVariantSku.sku);
            if (foundImages) {
                const otherImages = productVariantImages.filter((img)=>foundImages.split("|")[0] !== img.split("|")[0]);
                productVariantImagesFav = [
                    foundImages,
                    ...otherImages
                ];
            }
            variantImages = productVariantImages.filter((img)=>isVariantSku.sku === img.split("|")[0]);
            productVariantImages = [
                ...productVariantImagesFav
            ];
        } else {
            variantImages = productVariantImages.filter((img)=>sku === img.split("|")[0]);
        }
        if (props.plpPage) {
            variantImages.find((img)=>{
                const imgDetails = img.split("|");
                if (imgDetails[2] === props.defaultImage) return setDefaultProductImage = imgDetails[1];
                else setDefaultProductImage = variantImages[0].split("|")[1];
            });
            productVariantImages.find((img)=>{
                const imgDetails = img.split("|");
                if (imgDetails[2] === props.hoverImage) return setHoverProductImage = imgDetails[1];
            });
        } else {
            productVariantImages.find((img)=>{
                const imgDetails = img.split("|");
                if (isFavoriteIsVariantSelected) {
                    if (isVariantSku.sku === imgDetails[0]) return setDefaultProductImage = imgDetails[1];
                } else {
                    if (sku === imgDetails[0]) return setDefaultProductImage = imgDetails[1];
                }
            });
        }
        images.push(setDefaultProductImage);
        if (props.plpPage) {
            if (setHoverProductImage === "") {
                isHover = false;
            }
            isHover === false ? images.push(setDefaultProductImage) : images.push(setHoverProductImage);
        }
    } else {
        images = [
            "MissingImage"
        ];
    }
    // get variant image if color filters are applied
    let selColor = "";
    let variantPrice = 0;
    let variantDiscPrice = 0;
    if (props.mapImageToColor && props.currFilters) {
        const colorFilter = props.currFilters.find((q)=>q.facet === "Color.Finish" || q.facet === "Color" || q.facet === "Finish");
        const selColors = colorFilter === null || colorFilter === void 0 ? void 0 : colorFilter.value;
        if ((selColors === null || selColors === void 0 ? void 0 : selColors.length) > 0) {
            let selectedProductImage = "";
            var ref4;
            let i = (ref4 = (selColors === null || selColors === void 0 ? void 0 : selColors.length) - 1) !== null && ref4 !== void 0 ? ref4 : 0;
            while(!selectedProductImage && i >= 0){
                const colorName = selColors[i];
                if (data["Color.".concat(persona, ".Details_ss")]) {
                    var ref5, ref6;
                    var ref7;
                    const exactSKUDetails = (ref7 = (ref5 = data["Color.".concat(persona, ".Details_ss")].find((item)=>item.split("|")[1] === colorName)) === null || ref5 === void 0 ? void 0 : ref5.split("|")) !== null && ref7 !== void 0 ? ref7 : [];
                    selColor = selColors[i];
                    var ref8;
                    const productId = (ref8 = (ref6 = exactSKUDetails[5]) === null || ref6 === void 0 ? void 0 : ref6.split("?")[0].split("/").slice(-1)) !== null && ref8 !== void 0 ? ref8 : [];
                    var ref9;
                    selectedProductImage = (ref9 = productId[0]) !== null && ref9 !== void 0 ? ref9 : "";
                    var ref10;
                    variantPrice = (ref10 = exactSKUDetails[2]) !== null && ref10 !== void 0 ? ref10 : 0;
                    var ref11;
                    variantDiscPrice = (ref11 = exactSKUDetails[3]) !== null && ref11 !== void 0 ? ref11 : 0;
                }
                i--;
            }
            if (!selectedProductImage) selectedProductImage = "MissingImage";
            if (images[0] === images[1]) {
                images = [
                    selectedProductImage,
                    selectedProductImage
                ];
            } else {
                images[0] = selectedProductImage;
            }
        }
    }
    let colors = [];
    if (data["Color.SKU.Details_ss"]) {
        colors = data["Color.SKU.Details_ss"].map((color)=>{
            const d = color.split("|");
            return {
                name: d[0],
                swatch: d[1],
                sku: d[2],
                isStock: d[3],
                isDiscontinued: d[4],
                customerFacingSKU: d[5]
            };
        });
    }
    let selSku = "";
    if (props.mapImageToColor && selColor) {
        var ref12;
        var ref13;
        selSku = (ref13 = (ref12 = colors.find((item)=>item.name === selColor)) === null || ref12 === void 0 ? void 0 : ref12.sku) !== null && ref13 !== void 0 ? ref13 : "";
    } else {
        selSku = sku;
    }
    if (isFavoriteIsVariantSelected) {
        const foundColor = colors.find((item)=>item.sku === isVariantSku.sku);
        if (foundColor) {
            const otherColors = colors.filter((color)=>color.sku !== foundColor.sku);
            colors = [
                foundColor,
                ...otherColors
            ];
        }
        selSku = isFavoriteIsVariantSelected;
    }
    (0,react.useEffect)(()=>{
        var ref;
        (ref = window.wow) === null || ref === void 0 ? void 0 : ref.sync();
    }, []);
    (0,react.useEffect)(()=>{
        const compareSku = selSku !== "" ? selSku : sku;
        if (compareData.comparedProducts.find((prod)=>prod.compareSku === compareSku)) setIsChecked(true);
        else setIsChecked(false);
    }, [
        compareData.comparedProducts,
        data
    ]);
    colors = colors.filter((item)=>item.isDiscontinued === "false" || Date.parse(item.isDiscontinued) > Date.now());
    const tileTitle = get_default()(data, "Tile_Title", "");
    const { isBundleProduct =false , productLocaleName =""  } = data;
    const itemName = isGrouped ? get_default()(data, "Collapse_Title_s", "") : props.type === "parts" ? get_default()(data, "productName_s", "") : get_default()(data, "RegionBrandName_s", "") || get_default()(data, "ProductBrandName_s", "");
    const productName = isBundleProduct ? productLocaleName : itemName;
    const description = isGrouped ? get_default()(data, "Collapse_Description_s", "") : get_default()(data, "ProductDescriptionProductShort_s", "");
    var _ProductLocalCategory_s;
    const category = data.Product_Category ? data.Product_Category : (_ProductLocalCategory_s = data.ProductLocalCategory_s) !== null && _ProductLocalCategory_s !== void 0 ? _ProductLocalCategory_s : "";
    const shipmentDate = get_default()(data, "RegionReleaseforShipment_dt", "");
    const isNewProduct = (0,helper/* showNewBadge */.ZTk)(shipmentDate);
    const badgeVal = get_default()(data, "priceList.".concat(persona, ".saleOffer_s"), "");
    let discountedPrice = get_default()(data, "priceList.".concat(persona, ".finalPrice_d"), 0);
    let finalPrice = get_default()(data, "priceList.".concat(persona, ".price_d"), 0);
    const price = get_default()(data, "priceStartingAt.".concat(persona, "_d"), 0);
    const [tileUrl, setTileUrl] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        (0,helper/* getPDPUrl */.ir5)(category, data.slug_s).then((ret)=>setTileUrl(ret));
    }, [
        data
    ]);
    const exclusiveBadge = get_default()(data, "ProductIsExclusive_s", "");
    const isFavorite = ((ref = props.favorites) === null || ref === void 0 ? void 0 : ref.find((vl)=>vl.productId === data["ctId_s"])) ? true : false;
    const isDiscountedPrice = get_default()(data, "priceList.".concat(persona, ".discountedPrice_d"), 0);
    const detaultSelectedColor = colors.length ? (ref1 = colors[0]) === null || ref1 === void 0 ? void 0 : ref1.name : "";
    const defaultCustomerFacingSku = colors.length ? (ref2 = colors[0]) === null || ref2 === void 0 ? void 0 : ref2.customerFacingSKU : "";
    const defaultImage = images.length ? images[0] : "";
    const defaultProductIsInStock = colors.length ? colors[0].isStock === "true" || colors[0].isStock === true : false;
    const discountPercent = badgeVal && isDiscountedPrice ? 100 - Math.round(isDiscountedPrice / price * 100) : 0;
    const discountPriceState = badgeVal && isDiscountedPrice ? "percentOff|" + discountPercent : "regular price";
    const productIsRetail = get_default()(data, "ProductIsRetail", "") === "true" ? true : false;
    const isSuperSku = get_default()(data, "comboSKUAvailable_b", null) ? true : false;
    const discountAmount = discountPercent ? Number((price - isDiscountedPrice).toFixed(2)) : 0;
    const productSaleable = productIsRetail || !colors.length ? false : true;
    const productRoom = get_default()(data, "category1_s", "n/a");
    const productCollectionsName = get_default()(data, "ProductBrandNameDisplay_s", "n/a");
    if (isGrouped) {
        finalPrice = get_default()(data, "priceStartingAt.".concat(persona, "_d"), 0);
        discountedPrice = get_default()(data, "discountedPriceStartingAt.".concat(persona, "_d"), 0);
    } else if (props.mapImageToColor && selColor && variantPrice > 0) {
        finalPrice = variantPrice;
        discountedPrice = variantDiscPrice;
    } else if (props.exactSKU) {
        const exactSKUDetails1 = data["Color.".concat(persona, ".Details_ss")] ? data["Color.".concat(persona, ".Details_ss")].find((item)=>item.split("|")[0] === sku).split("|") : [];
        var ref14;
        finalPrice = (ref14 = exactSKUDetails1[2]) !== null && ref14 !== void 0 ? ref14 : 0;
        var ref15;
        discountedPrice = (ref15 = exactSKUDetails1[3]) !== null && ref15 !== void 0 ? ref15 : 0;
    }
    (0,react.useEffect)(()=>{
        if (currencyCode) getSkuPrice(isVariantSku.sku);
    }, [
        currencyCode,
        isVariantSku
    ]);
    if (loading) return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "product-tile--loading",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "loading-image shimmer"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "loading-title shimmer"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "loading-description shimmer"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                className: "loading-swatch",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "shimmer"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "shimmer"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "shimmer"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "shimmer"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "shimmer"
                    })
                ]
            })
        ]
    });
    const getSkuPrice = async (sku)=>{
        if (sku) {
            const payload = {
                slug: data["slug_s"],
                sku: sku,
                currencyCode,
                persona
            };
            const priceObj = await dispatch((0,favoritesSlice/* getProductBySlug */.Co)(payload));
            var _sku;
            setSkuVariantPrice((_sku = priceObj === null || priceObj === void 0 ? void 0 : priceObj.payload[sku]) !== null && _sku !== void 0 ? _sku : 0);
            var ref;
            setSkuVariantPriceDiscount((ref = priceObj === null || priceObj === void 0 ? void 0 : priceObj.payload["".concat(sku, "-discount")]) !== null && ref !== void 0 ? ref : 0);
        }
    };
    const handleFavorite = (e)=>{
        window.preActiveElement = e.target;
        e.stopPropagation();
        e.preventDefault();
        if (isFavorite === true) {
            var ref;
            (ref = props.favorites) === null || ref === void 0 ? void 0 : ref.map((fav)=>{
                if (fav.productId === data["ctId_s"]) {
                    isAuthenticated(()=>dispatch((0,favoritesSlice/* removeItems */.Er)([
                            fav.id
                        ], texts.removeItem, texts.removeItemError, handleCallBack)));
                }
            });
        } else {
            isAuthenticated(()=>dispatch((0,favoritesSlice/* addProduct */.gK)(sku, texts.favSuccessMsg, texts.favErrorMsg, handleCallBack)));
        }
    };
    const handleCallBack = (status, message)=>{
        var ref;
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        let isForSample = false;
        if (page && (page === null || page === void 0 ? void 0 : (ref = page.category) === null || ref === void 0 ? void 0 : ref.subCategory1)) {
            const { category: { subCategory1  }  } = page;
            isForSample = subCategory1.includes("samples");
        }
        const eventInfo = getEventInfo("favorite", null, true, isForSample);
        const productInfo = getProductInfo(null, true);
        eventInfo.eventStatus = status;
        eventInfo.eventMsg = (0,helper/* sanitizeTextForAnalytics */.T68)(message);
        window.adobeDataLayer.push({
            event: "cmp:click",
            page,
            eventInfo,
            productInfo
        });
    };
    const handleShare = (e)=>{
        e.stopPropagation();
        e.preventDefault();
        setShowShare(true);
    };
    const badgeTxt = isNewProduct ? exclusiveBadge ? texts.newExclusive : texts.new : exclusiveBadge ? texts.exclusive : "";
    const pageRedirectUrl = props.type === "parts" ? "".concat(tileUrl).concat(selSku ? "?skuId=" + selSku : "?skuId=" + sku) : "".concat(tileUrl).concat(selSku ? "?skuId=" + selSku : "");
    const redirectPDP = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        location.href = decodeURIComponent(pageRedirectUrl);
    };
    const setHover = ()=>{
        document.getElementById("kf-product-tile-wrapper-".concat(data["ctId_s"])).classList.add("--hover");
        setOnHover(true);
    };
    const removeHover = ()=>{
        document.getElementById("kf-product-tile-wrapper-".concat(data["ctId_s"])).classList.remove("--hover");
        setOnHover(false);
    };
    const presetConf = JSON.parse(presetConfigs);
    const getEventInfo = function(type, color) {
        let needsJSON = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, isForSample = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
        /**
     * type is default navigation, could be favorite or share
     * color is optional, could be selected color from plp or search page product
     * needsJSON returns either JSON or stringified value
     */ let alternameType;
        let compareInternalLinkName;
        if (type === "favorite") {
            if (isFavorite) {
                alternameType = "favorite remove";
            } else {
                alternameType = "favorite add";
            }
        } else if (type === "compare") {
            if (isChecked) {
                alternameType = "compare remove";
                compareInternalLinkName = "remove compare";
            } else {
                alternameType = "compare add";
                compareInternalLinkName = "add to compare";
            }
        }
        let selectedTab;
        let pageSection;
        if (props.favPage && props.selectedtab) {
            pageSection = "favorites";
            selectedTab = props.selectedtab.toLowerCase();
        }
        const plpPrefix = isForSample ? "plp:sample" : "plp";
        const selectedTabForSearchResults = props.type || "products";
        const eventInfo = {
            eventAction: "".concat(pageSection ? "my account:" + pageSection + ":" : (props.plpPage ? plpPrefix : "search results") + (isForSample ? ":" : " "), "product ").concat(alternameType || type || "navigation"),
            eventName: "".concat(pageSection ? "my account:" + pageSection + ":" : (props.plpPage ? plpPrefix : "search results") + (isForSample ? ":" : " "), "product ").concat(alternameType || type || "navigation"),
            eventType: isForSample || type === "favorite" ? "wishlist save" : "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: type === "compare" ? compareInternalLinkName : alternameType || (0,helper/* sanitizeTextForAnalytics */.T68)(type || productName + " " + description),
            internalLinkPosition: selectedTab !== null && selectedTab !== void 0 ? selectedTab : props.plpPage ? plpPrefix : "search results",
            internalLinkType: pageSection ? "my accounts:navigation" : "".concat(props.plpPage ? plpPrefix : "search results", ":").concat(type || (props.plpPage ? "navigation" : "product tiles")),
            internalLinkZoneName: selectedTab ? "my account:".concat(pageSection, ":").concat(selectedTab, ":main content area") : props.plpPage ? "".concat(plpPrefix, ":promo tiles") : "search results:".concat(selectedTabForSearchResults, ":main content area"),
            internalLinkURL: !type ? ((tileUrl === null || tileUrl === void 0 ? void 0 : tileUrl.indexOf("http")) === -1 ? window.location.origin : "") + tileUrl + (color ? "?skuId=" + color.sku : selSku ? "?skuId=" + selSku : "") : "n/a",
            clickInternalLinks: "true"
        };
        if (needsJSON) {
            eventInfo.custom = getProductInfo();
            return eventInfo;
        }
        return JSON.stringify(eventInfo);
    };
    const getProductInfo = function(color) {
        let needsJSON = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        const { productCouponCode , productCoupondiscount  } = (0,helper/* getCurrentSkuCouponDiscounts */.mPk)({
            cart: cartData,
            sku: sku
        });
        const productInfo = {
            productInfo: {
                productBrand: siteName === null || siteName === void 0 ? void 0 : siteName.toLowerCase(),
                description: (0,helper/* sanitizeTextForAnalytics */.T68)(description) || "n/a",
                globalPromotionPrice: discountPercent && discountAmount ? Number((price - discountAmount).toFixed(2)) : price,
                priceState: discountPriceState,
                productBasePrice: price,
                productCategory: (0,helper/* sanitizeTextForAnalytics */.T68)(category) || "n/a",
                productColor: (0,helper/* sanitizeTextForAnalytics */.T68)(color ? color.name : detaultSelectedColor) || "n/a",
                productID: (color ? color.customerFacingSKU : defaultCustomerFacingSku) || "n/a",
                productName: (0,helper/* sanitizeTextForAnalytics */.T68)(productName) || "n/a",
                productRoom: (0,helper/* sanitizeTextForAnalytics */.T68)(productRoom || category) || "n/a",
                productSalePrice: discountedPrice ? discountedPrice : price,
                productSaleable: productSaleable,
                productStatus: color ? color.isStock === "true" || color.isStock === true ? "in stock" : "out of stock" : defaultProductIsInStock ? "in stock" : "out of stock",
                productSuperSku: isSuperSku,
                productTileName: (0,helper/* sanitizeTextForAnalytics */.T68)(tileTitle) || "n/a",
                defaultImageName: defaultImage || "n/a",
                productCollectionsName: (0,helper/* sanitizeTextForAnalytics */.T68)(productCollectionsName || category) || "n/a",
                globalOffer: badgeVal ? badgeVal : "n/a",
                globalDiscount: discountPercent ? discountAmount : "n/a",
                productPartnerBuyNow: productIsRetail,
                pdpType: "regular finished goods & service parts",
                productFindingMethod: "n/a",
                productCouponCode: productCouponCode.join("|") || "n/a",
                productCoupondiscount: productCoupondiscount,
                frequency: "n/a",
                isRecommended: "n/a",
                isSendNow: "n/a",
                isSubscription: "n/a",
                quantity: "n/a",
                ratings: "n/a",
                numberOfReviews: "n/a"
            }
        };
        if (needsJSON) {
            return productInfo.productInfo;
        }
        return JSON.stringify(productInfo);
    };
    const handleOnClickPartsDiagramLink = (event)=>{
        event.preventDefault();
        props.handleOnClickPartsDiagramLink(data);
    };
    const { Brand_ss: BrandSs = []  } = data !== null && data !== void 0 ? data : {};
    const partsDiagram = texts === null || texts === void 0 ? void 0 : texts.partsdiagram;
    var ref16;
    const brandName = (ref16 = BrandSs[0]) !== null && ref16 !== void 0 ? ref16 : "";
    const brandNameTolower = brandName === null || brandName === void 0 ? void 0 : brandName.toLowerCase();
    const isSameBrand = brandNameTolower === null || brandNameTolower === void 0 ? void 0 : brandNameTolower.startsWith(siteName === null || siteName === void 0 ? void 0 : siteName.toLowerCase());
    const getHref = ()=>{
        if (isSameBrand) {
            return {
                href: "".concat(tileUrl).concat((tileUrl === null || tileUrl === void 0 ? void 0 : tileUrl.includes("?type=part")) ? "&" : "?", "skuId=").concat(selSku !== "" ? selSku : sku)
            };
        } else {
            return {};
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "kf-product-tile-wrapper-".concat(data["ctId_s"]),
        className: "product-tile__wrapper wow animate__fadeInUp",
        onFocus: setHover,
        onBlur: removeHover,
        onMouseLeave: ()=>setShowShare(false),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialShare/* default */.Z, {
                showModal: showShare,
                id: "kf-plp-tile-".concat(data["ctId_s"]),
                url: window.location.origin + tileUrl,
                onClose: ()=>setShowShare(false),
                analyticData: getEventInfo("share", null, true)
            }),
            !isFavoriteVariant ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "product-tile__badge",
                children: [
                    isEmpty_default()(badgeVal) && !isEmpty_default()(badgeTxt) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "product-tile__new",
                        children: badgeTxt
                    }) : null,
                    !isEmpty_default()(badgeVal) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "product-tile__offer",
                        children: texts.sale
                    }) : null
                ]
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                role: "link",
                id: props.id,
                className: "product-tile__wrapper__card",
                tabIndex: "0",
                onClick: isSameBrand ? redirectPDP : null,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()({
                        "product-tile": true,
                        "product-tile--lite": lite
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        tabIndex: "-1",
                        className: "gbh-data-layer",
                        "data-gbh-data-layer": getEventInfo(),
                        "data-gbh-data-layer-custom": getProductInfo(),
                        ...getHref(),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "product-tile__image wow animate__fadeInUp",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: swatchUrlData ? images.map((id, i)=>{
                                        const imgUrl = (0,utils/* getPresetUrl */.v$)(width, rowCols, swatchUrlData, id, presetConf);
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            role: "presentation",
                                            src: imgUrl,
                                            className: images.length > 1 && i === 0 ? "product-tile__image--hover" : "",
                                            alt: data.metaTitle_s,
                                            onError: (e)=>(0,utils/* onImageError */.Ac)(e, imgUrl)
                                        }, i);
                                    }) : null
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "product-tile__details wow animate__fadeInUp",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            props.favPage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "product-brand_name",
                                                children: brandName === "KohlerPlumbing" ? "KOHLER" : brandName
                                            }),
                                            productName && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                "aria-label": productName,
                                                className: "product-tile__title",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Highlight/* default */.Z, {
                                                    text: productName,
                                                    highlight: highlightText
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                "aria-label": "".concat(texts.productDescription).concat(description),
                                                className: "product-tile__description",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Highlight/* default */.Z, {
                                                    text: description,
                                                    highlight: highlightText
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            isGrouped && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "product-tile__startingat",
                                                children: texts.startingAt
                                            }),
                                            skuVariantPrice > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                "aria-label": "".concat(texts.salePriceAria).concat(data["displayPriceStartingAt_s"]),
                                                className: "product-tile__price ".concat(!isGrouped && "product-tile_paddingtop"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                    value: skuVariantPrice !== null && skuVariantPrice !== void 0 ? skuVariantPrice : 0,
                                                    displayType: "text",
                                                    thousandSeparator: true,
                                                    prefix: currencySign,
                                                    decimalScale: 2,
                                                    fixedDecimalScale: true
                                                })
                                            }),
                                            skuVariantPriceDiscount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                "aria-label": "".concat(texts.originalPriceAria, " ").concat(finalPrice !== null && finalPrice !== void 0 ? finalPrice : 0),
                                                className: "product-tile__discount-price",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                    value: skuVariantPriceDiscount !== null && skuVariantPriceDiscount !== void 0 ? skuVariantPriceDiscount : 0,
                                                    displayType: "text",
                                                    thousandSeparator: true,
                                                    prefix: currencySign,
                                                    decimalScale: 2,
                                                    fixedDecimalScale: true
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            !props.favPage && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "product-tile__share",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        id: "kf-add-to-fav-".concat(props.index),
                        className: "product-tile__share-icon",
                        tabIndex: "0",
                        "aria-hidden": width > 1024 ? onHover ? false : true : false,
                        onClick: handleFavorite,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            role: "presentation",
                            src: isFavorite ? wishlist_gray_filled/* default.src */.Z.src : wish/* default.src */.Z.src,
                            alt: texts.wishlist
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "product-tile__share-icon-plp gbh-data-layer",
                        tabIndex: "0",
                        "aria-hidden": width > 1024 ? onHover ? false : true : false,
                        "data-gbh-data-layer": getEventInfo("share"),
                        "data-gbh-data-layer-custom": getProductInfo(),
                        onClick: handleShare,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            role: "presentation",
                            src: share/* default.src */.Z.src,
                            alt: texts.share
                        })
                    })
                ]
            }),
            isPartsDiagramLinkVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product-tile__wrapper__card__parts",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "#",
                    className: "product-parts__viewer",
                    onClick: handleOnClickPartsDiagramLink,
                    children: partsDiagram
                })
            })
        ]
    });
};
/* harmony default export */ var v1_ProductTile = (ProductTile);

;// CONCATENATED MODULE: ./components/MyFavorites/v1/ProductTile.jsx







const ProductTile_ProductTile = (props)=>{
    const { data ={} , presetConfigs ={} , selectedtab ="" , index =0 , hideCompare =false , staticTexts ={} , swatchCount =0 , isFavoriteVariant =false , isVariantSku ={} , brandSwitcherItems =[]  } = props;
    const compare = (0,es/* useSelector */.v9)((state)=>state.compare);
    const [currencySign, setCurrencySign] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>{
            const currencySign = get_default()(config, "internationalization.currencySign", "");
            setCurrencySign(currencySign);
        });
    }, []);
    if (!data) return "";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "image-tile",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ProductTile, {
            index: index,
            hideCompare: hideCompare,
            data: data,
            texts: staticTexts,
            addToCompare: ()=>{},
            removeFromCompare: ()=>{},
            compareData: compare,
            isEnable: false,
            currencySign: currencySign,
            favPage: true,
            swatchCount: swatchCount,
            presetConfigs: presetConfigs,
            selectedtab: selectedtab,
            type: (data === null || data === void 0 ? void 0 : data.Brand_ss) && (data === null || data === void 0 ? void 0 : data.Brand_ss[0]) === constants.PLUMBING_SERVICE_PARTS ? constants.PARTS : "",
            isFavoriteVariant: isFavoriteVariant,
            isVariantSku: isVariantSku,
            brandSwitcherItems: brandSwitcherItems
        })
    });
};
/* harmony default export */ var MyFavorites_v1_ProductTile = (ProductTile_ProductTile);

;// CONCATENATED MODULE: ./public/icons/play-white.svg
/* harmony default export */ var play_white = ({"src":"/_next/static/media/play-white.f1d147a3.svg","height":40,"width":40});
;// CONCATENATED MODULE: ./components/MyFavorites/analytics/index.js
const addAnalyticsArticleClick = (title, url)=>{
    const eventInfo = {
        eventAction: "my account:favorites:all:".concat(title),
        eventName: "my account:favorites:all:".concat(title),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: title,
        internalLinkPosition: "favorites",
        internalLinkType: "my account:navigation",
        internalLinkURL: url,
        clickInternalLinks: "true",
        internalLinkZoneName: "my account:favorites:all"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addAnalyticsVideoClick = (videoTitle, videoUrl, videoId)=>{
    const eventInfo = {
        eventAction: "my account:favorites:video play",
        eventName: "my account:favorites:video play",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "video play",
        internalLinkPosition: "favorites",
        internalLinkType: "my account:navigation",
        internalLinkURL: videoUrl,
        clickInternalLinks: "true",
        internalLinkZoneName: "my account:favorites:videos",
        videoName: videoTitle,
        videoId: videoId
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const addAnalyticsVideoClose = (videoTitle, videoUrl, videoId)=>{
    const eventInfo = {
        eventAction: "my account:favorites:".concat(videoTitle, ":close"),
        eventName: "my account:favorites:".concat(videoTitle, ":close"),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "close",
        internalLinkPosition: "favorites",
        internalLinkType: "my account:navigation",
        internalLinkURL: videoUrl,
        clickInternalLinks: "true",
        internalLinkZoneName: "my account:favorites:videos",
        videoName: videoTitle,
        videoId: videoId
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const pushAnalyticsObjToDataLayer = function() {
    let eventInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const event = "cmp:click";
    window.adobeDataLayer.push({
        event,
        eventInfo,
        page
    });
};

;// CONCATENATED MODULE: ./components/MyFavorites/v1/VideoTile.jsx





const VideoTile = (param)=>{
    let { url ="" , data ={}  } = param;
    const [showModal, setShowModal] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        if (showModal) {
            document.body.classList.add("modal-open");
        } else {
            document.body.classList.remove("modal-open");
        }
    }, [
        showModal
    ]);
    const handleModal = function() {
        let isOpen = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        var ref, ref1, ref2;
        const videoName = (data === null || data === void 0 ? void 0 : data.name) && (((ref = data.name["en-US"]) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || ((ref1 = data.name["en-CA"]) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) || "");
        const videoId = url && ((ref2 = url.split("/")) === null || ref2 === void 0 ? void 0 : ref2.length) ? url.split("/").pop() : "";
        if (isOpen) {
            addAnalyticsVideoClick(videoName, url, videoId);
        } else {
            addAnalyticsVideoClose(videoName, url, videoId);
        }
        setShowModal((prevShowModal)=>!prevShowModal);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "video-tile",
                tabIndex: "0",
                role: "link",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "play-icon",
                        onClick: ()=>handleModal(true),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: play_white === null || play_white === void 0 ? void 0 : play_white.src,
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                        controls: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                            src: url,
                            type: "video/mp4"
                        })
                    })
                ]
            }),
            showModal && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "favorites-lightbox",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "favorites-lightbox__modal",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "favorites-lightbox__close",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: icons_close/* default */.Z === null || icons_close/* default */.Z === void 0 ? void 0 : icons_close/* default.src */.Z.src,
                                alt: "close",
                                onClick: ()=>handleModal(false)
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                            autoPlay: true,
                            "webkit-playsinline": "true",
                            playsInline: true,
                            preload: "none",
                            controls: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                src: url,
                                type: "video/mp4"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var v1_VideoTile = (VideoTile);

;// CONCATENATED MODULE: ./components/MyFavorites/v1/ArticleTile.jsx





const ArticleTile = (param)=>{
    let { data , locale  } = param;
    const link = get_default()(data, "custom.fields.link", "");
    const categoryName = get_default()(data, "custom.fields.articleType", "");
    const title = get_default()(data, "name[".concat(locale, "]"), "");
    const description = get_default()(data, "description[".concat(locale, "]"), "");
    const thumbnail = get_default()(data, "custom.fields.thumbnail", "");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
        href: link,
        className: "article-tile",
        "aria-label": title,
        onClick: ()=>addAnalyticsArticleClick(title.toLowerCase(), link),
        "data-siteWideWarning-added": "true",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "content-section",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "category-name",
                        children: categoryName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "article-title",
                        children: title
                    }),
                    description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "description",
                        children: (0,helper/* sanitizeTextArticle */.pkm)(description)
                    })
                ]
            }),
            thumbnail && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "image-section",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: thumbnail,
                    alt: "image"
                })
            })
        ]
    });
};
/* harmony default export */ var v1_ArticleTile = (ArticleTile);

;// CONCATENATED MODULE: ./public/icons/fav-add.svg
/* harmony default export */ var fav_add = ({"src":"/_next/static/media/fav-add.73876466.svg","height":14,"width":14});
;// CONCATENATED MODULE: ./public/icons/fav-tick.svg
/* harmony default export */ var fav_tick = ({"src":"/_next/static/media/fav-tick.6ed9751e.svg","height":11,"width":14});
;// CONCATENATED MODULE: ./components/MyFavorites/v1/FavoritesTile.jsx












const FavoritesTile = (props)=>{
    var ref, ref1, ref2;
    const { fid ="" , data ={} , editMode =false , isSelected =false , locale ="" , onSelect =()=>{} , selectedtab ="" , isAuth =false , user ={} , staticTexts ={} , presetConfigs ="" , smartCrop ={} , isGrouped =false , exactSKU =false , mapImageToColor , currFilters =[] , type ="" , swatchCount =0 , index =0 , brandSwitcherItems =[]  } = props;
    const selected = isSelected(fid);
    const { custom: { fields: { itemType ="" , link =""  } = {}  } = {}  } = data;
    const persona = (0,helper/* getUserPersona */.shu)();
    const cartData = (0,es/* useSelector */.v9)((state)=>{
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.cart) === null || ref === void 0 ? void 0 : ref.data;
    });
    const [siteName, setSiteName] = (0,react.useState)();
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>{
            const brandName = get_default()(config, "general.siteName");
            setSiteName(brandName);
        });
    }, []);
    const { productData ={} , name ={} , variant: { attributes =[]  } = {}  } = data;
    var ref3;
    const sku = exactSKU ? exactSKU : (ref3 = data === null || data === void 0 ? void 0 : (ref = data.variant) === null || ref === void 0 ? void 0 : ref.sku) !== null && ref3 !== void 0 ? ref3 : "";
    if (mapImageToColor && currFilters) {
        const colorFilter = currFilters === null || currFilters === void 0 ? void 0 : currFilters.find((q)=>q.facet === "Color.Finish" || q.facet === "Color" || q.facet === "Finish");
        const selColors = colorFilter === null || colorFilter === void 0 ? void 0 : colorFilter.value;
        if ((selColors === null || selColors === void 0 ? void 0 : selColors.length) > 0) {
            let selectedProductImage = "";
            var ref4;
            let i = (ref4 = (selColors === null || selColors === void 0 ? void 0 : selColors.length) - 1) !== null && ref4 !== void 0 ? ref4 : 0;
            while(!selectedProductImage && i >= 0){
                const colorName = selColors[i];
                if (productData["Color.".concat(persona, ".Details_ss")]) {
                    var ref5, ref6;
                    var ref7;
                    const exactSKUDetails = (ref7 = (ref5 = productData["Color.".concat(persona, ".Details_ss")].find((item)=>item.split("|")[1] === colorName)) === null || ref5 === void 0 ? void 0 : ref5.split("|")) !== null && ref7 !== void 0 ? ref7 : [];
                    var ref8;
                    const productId = (ref8 = (ref6 = exactSKUDetails[5]) === null || ref6 === void 0 ? void 0 : ref6.split("?")[0].split("/").slice(-1)) !== null && ref8 !== void 0 ? ref8 : [];
                    var ref9;
                    selectedProductImage = (ref9 = productId[0]) !== null && ref9 !== void 0 ? ref9 : "";
                }
                i--;
            }
            if (!selectedProductImage) selectedProductImage = "MissingImage";
            if (images[0] === images[1]) {
                images = [
                    selectedProductImage,
                    selectedProductImage
                ];
            } else {
                images[0] = selectedProductImage;
            }
        }
    }
    let colors = [];
    let images = [];
    if (productData["Color.SKU.Details_ss"]) {
        var ref10;
        colors = (ref10 = productData["Color.SKU.Details_ss"]) === null || ref10 === void 0 ? void 0 : ref10.map((color)=>{
            const d = color === null || color === void 0 ? void 0 : color.split("|");
            return {
                name: d[0],
                swatch: d[1],
                sku: d[2],
                isStock: d[3],
                isDiscontinued: d[4],
                customerFacingSKU: d[5]
            };
        });
    }
    colors = colors === null || colors === void 0 ? void 0 : colors.filter((item)=>item.isDiscontinued === "false" || Date.parse(item.isDiscontinued) > Date.now());
    const { Collapse_Title_s: collapseTitles = "" , productName_s: productNames = "" , RegionBrandName_s: regionBrandNames = "" , ProductBrandName_s: productBrandNames = "" , Tile_Title: tileTitle , Collapse_Description_s: collapseDescriptions = "" , ProductDescriptionProductShort_s: productDescriptionProductShorts = "" , Product_Category: productCategory = "" , ProductLocalCategory_s: productLocalCategorys = ""  } = productData;
    const productLocaleName = name[locale];
    const isBundleProduct = Boolean(attributes.find((e)=>e.name === "primaryProduct"));
    const itemName = isGrouped ? collapseTitles : type === "parts" ? productNames : regionBrandNames || productBrandNames;
    const productName = isBundleProduct ? productLocaleName : itemName;
    const description = isGrouped ? collapseDescriptions : productDescriptionProductShorts;
    const category = productCategory ? productCategory : productLocalCategorys;
    const badgeVal = get_default()(productData, "priceList.".concat(persona, ".saleOffer_s"), "");
    const discountedPrice = get_default()(productData, "priceList.".concat(persona, ".finalPrice_d"), 0);
    const price = get_default()(productData, "priceStartingAt.".concat(persona, "_d"), 0);
    const isDiscountedPrice = get_default()(productData, "priceList.".concat(persona, ".discountedPrice_d"), 0);
    const detaultSelectedColor = colors.length ? (ref1 = colors[0]) === null || ref1 === void 0 ? void 0 : ref1.name : "";
    const defaultCustomerFacingSku = colors.length ? (ref2 = colors[0]) === null || ref2 === void 0 ? void 0 : ref2.customerFacingSKU : "";
    const defaultImage = images.length ? images[0] : "";
    const defaultProductIsInStock = colors.length ? colors[0].isStock === "true" || colors[0].isStock === true : false;
    const discountPercent = badgeVal && isDiscountedPrice ? 100 - Math.round(isDiscountedPrice / price * 100) : 0;
    const discountPriceState = badgeVal && isDiscountedPrice ? "percentOff|" + discountPercent : "regular price";
    const productIsRetail = get_default()(productData, "ProductIsRetail", "") === "true" ? true : false;
    const isSuperSku = get_default()(productData, "comboSKUAvailable_b", null) ? true : false;
    const discountAmount = discountPercent ? Number((price - isDiscountedPrice).toFixed(2)) : 0;
    const productSaleable = productIsRetail || !colors.length ? false : true;
    const productRoom = get_default()(productData, "category1_s", "n/a");
    const productCollectionsName = get_default()(productData, "ProductBrandNameDisplay_s", "n/a");
    const getEventInfo = ()=>{
        const type = selected ? "select" : "unselect";
        const eventInfo = {
            eventAction: "my account:favorites:".concat(selectedtab.toLowerCase(), ":").concat(type),
            eventName: "my account:favorites:".concat(selectedtab.toLowerCase(), ":").concat(type),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: type,
            internalLinkPosition: "favorites",
            internalLinkType: "my account:".concat(type),
            internalLinkZoneName: "my account:favorites:".concat(selectedtab.toLowerCase()),
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        };
        return JSON.stringify(eventInfo);
    };
    const getProductInfo = function(color) {
        let needsJSON = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var ref;
        const { productCouponCode , productCoupondiscount  } = (0,helper/* getCurrentSkuCouponDiscounts */.mPk)({
            cart: cartData,
            sku: sku
        });
        const productInfo = {
            productInfo: {
                productBrand: siteName === null || siteName === void 0 ? void 0 : (ref = siteName.siteName) === null || ref === void 0 ? void 0 : ref.toLowerCase(),
                description: (0,helper/* sanitizeTextForAnalytics */.T68)(description) || "n/a",
                globalPromotionPrice: discountPercent && discountAmount ? Number((price - discountAmount).toFixed(2)) : price,
                priceState: discountPriceState,
                productBasePrice: price,
                productCategory: (0,helper/* sanitizeTextForAnalytics */.T68)(category) || "n/a",
                productColor: (0,helper/* sanitizeTextForAnalytics */.T68)(color ? color.name : detaultSelectedColor) || "n/a",
                productID: (color ? color.customerFacingSKU : defaultCustomerFacingSku) || "n/a",
                productName: (0,helper/* sanitizeTextForAnalytics */.T68)(productName) || "n/a",
                productRoom: (0,helper/* sanitizeTextForAnalytics */.T68)(productRoom || category) || "n/a",
                productSalePrice: discountedPrice ? discountedPrice : price,
                productSaleable: productSaleable,
                productStatus: color ? color.isStock === "true" || color.isStock === true ? "in stock" : "out of stock" : defaultProductIsInStock ? "in stock" : "out of stock",
                productSuperSku: isSuperSku,
                productTileName: (0,helper/* sanitizeTextForAnalytics */.T68)(tileTitle) || "n/a",
                defaultImageName: defaultImage || "n/a",
                productCollectionsName: (0,helper/* sanitizeTextForAnalytics */.T68)(productCollectionsName || category) || "n/a",
                globalOffer: badgeVal ? badgeVal : "n/a",
                globalDiscount: discountPercent ? discountAmount : "n/a",
                productPartnerBuyNow: productIsRetail,
                pdpType: "regular finished goods & service parts",
                productFindingMethod: "n/a",
                productCouponCode: productCouponCode.join("|") || "n/a",
                productCoupondiscount: productCoupondiscount,
                frequency: "n/a",
                isRecommended: "n/a",
                isSendNow: "n/a",
                isSubscription: "n/a",
                quantity: "n/a",
                ratings: "n/a",
                numberOfReviews: "n/a"
            }
        };
        if (needsJSON) {
            return productInfo.productInfo;
        }
        return JSON.stringify(productInfo);
    };
    const productTileData = {
        ...data === null || data === void 0 ? void 0 : data.productData,
        productLocaleName,
        isBundleProduct
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "edit-wrapper item ".concat(editMode && selected ? "--selected" : "", " ", "myfavorite-imagetile", " ", "myfavorite-videotile", " ", "myfavorite-producttile"),
        role: "listitem",
        children: [
            editMode && // eslint-disable-next-line jsx-a11y/role-supports-aria-props
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: "icon-select gbh-data-layer",
                role: "button",
                tabIndex: "0",
                "aria-selected": selected,
                "data-gbh-data-layer": getEventInfo(),
                "data-gbh-data-layer-custom": getProductInfo(),
                onClick: ()=>onSelect(fid),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    role: "presentation",
                    src: selected ? fav_tick === null || fav_tick === void 0 ? void 0 : fav_tick.src : fav_add === null || fav_add === void 0 ? void 0 : fav_add.src,
                    alt: ""
                })
            }),
            itemType === "image" && /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ImageTile, {
                url: link,
                altText: data.name[locale],
                smartCrop: smartCrop
            }, link),
            itemType === "video" && /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_VideoTile, {
                url: link,
                data: data
            }, link),
            itemType === "article" && /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ArticleTile, {
                data: data,
                locale: locale
            }),
            (data === null || data === void 0 ? void 0 : data.productId) && /*#__PURE__*/ (0,jsx_runtime.jsx)(MyFavorites_v1_ProductTile, {
                index: index,
                data: productTileData,
                hideCompare: true,
                isAuth: isAuth,
                user: user,
                staticTexts: staticTexts,
                swatchCount: swatchCount,
                presetConfigs: presetConfigs,
                selectedtab: selectedtab,
                isFavoriteVariant: true,
                isVariantSku: data === null || data === void 0 ? void 0 : data.variant,
                brandSwitcherItems: brandSwitcherItems
            })
        ]
    });
};
/* harmony default export */ var v1_FavoritesTile = (FavoritesTile);

// EXTERNAL MODULE: ./node_modules/isomorphic-dompurify/browser.js
var browser = __webpack_require__(29238);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
;// CONCATENATED MODULE: ./components/MyFavorites/v1/analytics/constant.js
const constant_NAVIGATION = "navigation";
const FAVORITES = "favorites";

;// CONCATENATED MODULE: ./components/MyFavorites/v1/analytics/index.js


const favNoResultDataLayer = (e)=>{
    const { target: { href ="" , textContent =""  } = {}  } = e;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const { category: { pageType  } = {}  } = page;
    const text = textContent.toLowerCase();
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageType, ":").concat(FAVORITES, ":").concat(text),
        eventName: "".concat(pageType, ":").concat(FAVORITES, ":").concat(text),
        eventMsg: "n/a",
        eventStatus: "n/a",
        eventType: constant_NAVIGATION,
        internalLinkName: text,
        internalLinkPosition: FAVORITES,
        internalLinkType: "".concat(pageType, ":").concat(constant_NAVIGATION),
        internalLinkZoneName: "".concat(pageType, ":").concat(FAVORITES),
        internalLinkURL: href
    };
    (0,helper/* pushAnalyticsObjToDataLayer */.zYT)(eventInfo);
};

;// CONCATENATED MODULE: ./components/MyFavorites/v1/FavoriteNoResult.jsx





const FavoriteNoResult = (props)=>{
    const { authoredContent ={}  } = props;
    const [finalUrl, setFinalUrl] = (0,react.useState)("");
    const continueshoppingRef = (0,react.useRef)();
    (0,react.useEffect)(()=>{
        if (authoredContent === null || authoredContent === void 0 ? void 0 : authoredContent.continueShoppingText) {
            (0,helper/* getShortenedUrl */.Ppy)(authoredContent === null || authoredContent === void 0 ? void 0 : authoredContent.continueShoppingText).then((res)=>setFinalUrl(res));
        }
    }, [
        authoredContent === null || authoredContent === void 0 ? void 0 : authoredContent.continueShoppingText
    ]);
    (0,react.useEffect)(()=>{
        if (continueshoppingRef === null || continueshoppingRef === void 0 ? void 0 : continueshoppingRef.current) {
            var ref;
            continueshoppingRef === null || continueshoppingRef === void 0 ? void 0 : (ref = continueshoppingRef.current) === null || ref === void 0 ? void 0 : ref.querySelectorAll("a").forEach((item)=>{
                item === null || item === void 0 ? void 0 : item.addEventListener("click", (e)=>{
                    favNoResultDataLayer(e);
                });
            });
        }
        return ()=>{
            var ref;
            continueshoppingRef === null || continueshoppingRef === void 0 ? void 0 : (ref = continueshoppingRef.current) === null || ref === void 0 ? void 0 : ref.querySelectorAll("a").forEach((item)=>{
                item === null || item === void 0 ? void 0 : item.removeEventListener("click", (e)=>{
                    favNoResultDataLayer(e);
                });
            });
        };
    }, [
        finalUrl
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "favorite-no-results",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container favorites__container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "favorites__title",
                    children: authoredContent === null || authoredContent === void 0 ? void 0 : authoredContent.title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "no-result-description",
                dangerouslySetInnerHTML: {
                    __html: browser_default().sanitize(authoredContent === null || authoredContent === void 0 ? void 0 : authoredContent.description)
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "redirect-to-shopping",
                ref: continueshoppingRef,
                dangerouslySetInnerHTML: {
                    __html: browser_default().sanitize(finalUrl)
                }
            })
        ]
    });
};
/* harmony default export */ var v1_FavoriteNoResult = (FavoriteNoResult);

// EXTERNAL MODULE: ./components/ListConfirmationModal/index.jsx + 1 modules
var ListConfirmationModal = __webpack_require__(63652);
// EXTERNAL MODULE: ./components/MyFavorites/v1/MyList/localization.js
var localization = __webpack_require__(57493);
// EXTERNAL MODULE: ./constants/routes.js
var routes = __webpack_require__(64757);
// EXTERNAL MODULE: ./components/Shared/Image/index.js
var Image = __webpack_require__(70914);
;// CONCATENATED MODULE: ./components/MyFavorites/v1/MyList/helper.js
const getProductPrice = (product, productQtyObj, listItemsPrice)=>{
    const quantity = productQtyObj[product["masterSKU_s"]] || 1;
    const price = listItemsPrice[product["masterSKU_s"]] || 0;
    return price * quantity;
};
const getListTotalPrice = (productData, productQtyObj, listItemsPrice)=>{
    let totalPrice = 0;
    productData === null || productData === void 0 ? void 0 : productData.map((product)=>{
        var ref;
        const price = (ref = listItemsPrice[product["masterSKU_s"]]) !== null && ref !== void 0 ? ref : 0;
        const quantity = productQtyObj[product["masterSKU_s"]] || 1;
        totalPrice += price * quantity;
    });
    return totalPrice;
};
const getColors = (product)=>{
    var ref;
    const colors = product === null || product === void 0 ? void 0 : (ref = product["Color.SKU.Details_ss"]) === null || ref === void 0 ? void 0 : ref.map((item)=>{
        const [name, swatch, sku, isDiscontinued, isStock, customerFacingSKU] = item.split("|");
        return {
            name,
            swatch,
            sku,
            isDiscontinued,
            isStock,
            customerFacingSKU
        };
    });
    return colors === null || colors === void 0 ? void 0 : colors.filter((color)=>product["masterSKU_s"] === color.sku);
};
const getFormattedDate = (currentList)=>{
    const dateObj = new Date(currentList === null || currentList === void 0 ? void 0 : currentList.createdAt);
    const month = dateObj === null || dateObj === void 0 ? void 0 : dateObj.toLocaleString("default", {
        month: "long"
    });
    const day = dateObj.getDate();
    const year = dateObj === null || dateObj === void 0 ? void 0 : dateObj.getFullYear();
    // Format the date as "Month Day, Year"
    const formattedDate = "".concat(month, " ").concat(day, ", ").concat(year);
    return formattedDate !== null && formattedDate !== void 0 ? formattedDate : "";
};
const getLineItemsProductImage = (data)=>{
    const sku = data["masterSKU_s"];
    let imagestmp = [];
    const productVariantImages = data["productImages.labelWithUrl_ss"] ? data["productImages.labelWithUrl_ss"] : [];
    let setDefaultProductImage = "";
    if ((productVariantImages === null || productVariantImages === void 0 ? void 0 : productVariantImages.length) > 0) {
        productVariantImages.find((img)=>{
            const imgDetails = img.split("|");
            if (sku === imgDetails[0]) return setDefaultProductImage = imgDetails[1];
        });
        setDefaultProductImage ? imagestmp.push(setDefaultProductImage) : imagestmp.push("MissingImage");
    } else {
        imagestmp = [
            "MissingImage"
        ];
    }
    return imagestmp;
};
const listItemQuantityChangeTypeAndValueCal = (qty, product, productQtyObj)=>{
    const currentQuantity = productQtyObj[product["masterSKU_s"]];
    if (currentQuantity > qty) {
        return {
            updatedQuantity: currentQuantity - qty,
            actionType: "subtract"
        };
    } else if (currentQuantity < qty) {
        return {
            updatedQuantity: qty - currentQuantity,
            actionType: "add"
        };
    } else {
        return {
            updatedQuantity: "",
            actionType: ""
        };
    }
};

;// CONCATENATED MODULE: ./public/images/No-Products-Yet.png
/* harmony default export */ var No_Products_Yet = ({"src":"/_next/static/media/No-Products-Yet.3911d2b6.png","height":796,"width":996,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAADFBMVEX29vbx8fHr6+v5+fkLy1xWAAAAA3RSTlP8/Paqf7fyAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAIklEQVQImWNghgIGEAYTzMwMjIwgEokBVcPAwMjExMjAAAAMBgBldQ8MCAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./components/MyFavorites/v1/MyList/constant.js
const constant_MY_ACCOUNT = "my account";
const MyList_constant_NAVIGATION = "navigation";
const WISHLIST_SAVE = "wishlist save";
const NEWEST_TO_OLDEST = "newest to oldest";
const OLDEST_TO_NEWEST = "oldest to newest";
const LISTS = "lists";
const MY_LISTS = "my lists";
const KOHLER = "kohler";
const ACCOUNT_SETTINGS = "account settings";

;// CONCATENATED MODULE: ./components/MyFavorites/v1/MyList/analytics.js


const pushToAdobeDataLayer = (eventInfo, listInfo)=>{
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = (getState === null || getState === void 0 ? void 0 : getState("page")) || {};
    page.category.pageType = "my list";
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        ...listInfo ? {
            listInfo
        } : {},
        page
    });
};
const dataLayerViewListButton = (myListTitle, viewListCTATitle, listName, listInfo, idView)=>{
    const myListHeading = myListTitle === null || myListTitle === void 0 ? void 0 : myListTitle.toLowerCase();
    const viewListCTAHeading = viewListCTATitle === null || viewListCTATitle === void 0 ? void 0 : viewListCTATitle.toLowerCase();
    const url = routes/* MY_LISTS_PAGE_PATH */.PN;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(constant_MY_ACCOUNT, ":").concat(myListHeading, ":").concat(viewListCTAHeading),
        eventMsg: "n/a",
        eventName: "".concat(constant_MY_ACCOUNT, ":").concat(myListHeading, ":").concat(viewListCTAHeading),
        eventStatus: "n/a",
        eventType: "".concat(MyList_constant_NAVIGATION),
        internalLinkName: "".concat(viewListCTAHeading),
        internalLinkPosition: "".concat(constant_MY_ACCOUNT, ":").concat(myListHeading),
        internalLinkType: "".concat(constant_MY_ACCOUNT, ":").concat(myListHeading, ":").concat(listName),
        internalLinkURL: "".concat(window.location.origin).concat(url).concat(idView),
        internalLinkZoneName: "".concat(constant_MY_ACCOUNT, ":").concat(myListHeading)
    };
    pushToAdobeDataLayer(eventInfo, listInfo);
};
const dataLayerShopBestSellerButton = (myListTitle, shopBestSellerCTATitle, listName, listInfo)=>{
    const myListHeading = myListTitle === null || myListTitle === void 0 ? void 0 : myListTitle.toLowerCase();
    const shopBestSellerCTAHeading = shopBestSellerCTATitle === null || shopBestSellerCTATitle === void 0 ? void 0 : shopBestSellerCTATitle.toLowerCase();
    const urlP = routes/* PRODUCT_BEST_SELLERS */.RG;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(constant_MY_ACCOUNT, ":").concat(myListHeading, ":").concat(shopBestSellerCTAHeading),
        eventMsg: "n/a",
        eventName: "".concat(constant_MY_ACCOUNT, ":").concat(myListHeading, ":").concat(shopBestSellerCTAHeading),
        eventStatus: "n/a",
        eventType: "".concat(MyList_constant_NAVIGATION),
        internalLinkName: "".concat(shopBestSellerCTAHeading),
        internalLinkPosition: "".concat(constant_MY_ACCOUNT, ":").concat(myListHeading),
        internalLinkType: "".concat(constant_MY_ACCOUNT, ":").concat(myListHeading, ":").concat(listName),
        internalLinkURL: "".concat(window.location.origin).concat(urlP),
        internalLinkZoneName: "".concat(constant_MY_ACCOUNT, ":").concat(myListHeading)
    };
    pushToAdobeDataLayer(eventInfo, listInfo);
};
const dataLayerDeleteListButton = (myListTitle, deleteListTitle, listName, listInfo)=>{
    const myListHeading = myListTitle === null || myListTitle === void 0 ? void 0 : myListTitle.toLowerCase();
    const deleteListHeading = deleteListTitle === null || deleteListTitle === void 0 ? void 0 : deleteListTitle.toLowerCase();
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(constant_MY_ACCOUNT, ":").concat(myListHeading, ":").concat(deleteListHeading),
        eventMsg: "n/a",
        eventName: "".concat(constant_MY_ACCOUNT, ":").concat(myListHeading, ":").concat(deleteListHeading),
        eventStatus: "n/a",
        eventType: "".concat(MyList_constant_NAVIGATION),
        internalLinkName: "".concat(deleteListHeading),
        internalLinkPosition: "".concat(constant_MY_ACCOUNT, ":").concat(myListHeading),
        internalLinkType: "".concat(constant_MY_ACCOUNT, ":").concat(myListHeading, ":").concat(listName),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(constant_MY_ACCOUNT, ":").concat(myListHeading)
    };
    pushToAdobeDataLayer(eventInfo, listInfo);
};
const dataLayerCreateNewMyListButton = (myListTitle, createNewListTitle)=>{
    const myListHeading = myListTitle === null || myListTitle === void 0 ? void 0 : myListTitle.toLowerCase();
    const createNewListHeading = createNewListTitle === null || createNewListTitle === void 0 ? void 0 : createNewListTitle.toLowerCase();
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(constant_MY_ACCOUNT, ":").concat(myListHeading, ":").concat(createNewListHeading),
        eventMsg: "n/a",
        eventName: "".concat(constant_MY_ACCOUNT, ":").concat(myListHeading, ":").concat(createNewListHeading),
        eventStatus: "n/a",
        eventType: "".concat(WISHLIST_SAVE),
        internalLinkName: "".concat(createNewListHeading),
        internalLinkPosition: "".concat(constant_MY_ACCOUNT, ":").concat(myListHeading),
        internalLinkType: "".concat(constant_MY_ACCOUNT, ":").concat(myListHeading),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(constant_MY_ACCOUNT, ":").concat(myListHeading)
    };
    pushToAdobeDataLayer(eventInfo);
};
const dataLayerlistTab = (myListTitle, tabListTitle)=>{
    const myListHeading = myListTitle === null || myListTitle === void 0 ? void 0 : myListTitle.toLowerCase();
    const listTabHeading = tabListTitle === null || tabListTitle === void 0 ? void 0 : tabListTitle.toLowerCase();
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(constant_MY_ACCOUNT, ":").concat(myListHeading, ":").concat(listTabHeading),
        eventMsg: "n/a",
        eventName: "".concat(constant_MY_ACCOUNT, ":").concat(myListHeading, ":").concat(listTabHeading),
        eventStatus: "n/a",
        eventType: "".concat(MyList_constant_NAVIGATION),
        internalLinkName: "".concat(listTabHeading),
        internalLinkPosition: "".concat(constant_MY_ACCOUNT, ":").concat(myListHeading),
        internalLinkType: "".concat(constant_MY_ACCOUNT, ":").concat(myListHeading, ":").concat(listTabHeading),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(constant_MY_ACCOUNT, ":").concat(myListHeading)
    };
    pushToAdobeDataLayer(eventInfo);
};
const dataLayerMediaTab = (myListTitle, mediaTabTitle)=>{
    const myListHeading = myListTitle === null || myListTitle === void 0 ? void 0 : myListTitle.toLowerCase();
    const mediaTabHeading = mediaTabTitle === null || mediaTabTitle === void 0 ? void 0 : mediaTabTitle.toLowerCase();
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(MY_ACCOUNT, ":").concat(myListHeading, ":").concat(mediaTabHeading),
        eventMsg: "n/a",
        eventName: "".concat(MY_ACCOUNT, ":").concat(myListHeading, ":").concat(mediaTabHeading),
        eventStatus: "n/a",
        eventType: "".concat(NAVIGATION),
        internalLinkName: "".concat(mediaTabHeading),
        internalLinkPosition: "".concat(MY_ACCOUNT, ":").concat(myListHeading),
        internalLinkType: "".concat(MY_ACCOUNT, ":").concat(myListHeading).concat(mediaTabHeading),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(MY_ACCOUNT, ":").concat(myListHeading)
    };
    pushToAdobeDataLayer(eventInfo);
};
const dataLayerNewestToOldest = (myListTitle, sortByTitle)=>{
    const myListHeading = myListTitle === null || myListTitle === void 0 ? void 0 : myListTitle.toLowerCase();
    const sortByHeading = sortByTitle === null || sortByTitle === void 0 ? void 0 : sortByTitle.toLowerCase();
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(constant_MY_ACCOUNT, ":").concat(myListHeading, ":").concat(LISTS, ":").concat(sortByHeading),
        eventMsg: "n/a",
        eventName: "".concat(constant_MY_ACCOUNT, ":").concat(myListHeading, ":").concat(LISTS, ":").concat(sortByHeading),
        eventStatus: "n/a",
        eventType: "".concat(MyList_constant_NAVIGATION),
        internalLinkName: "".concat(NEWEST_TO_OLDEST),
        internalLinkPosition: "".concat(constant_MY_ACCOUNT, ":").concat(myListHeading, ":").concat(LISTS),
        internalLinkType: "".concat(constant_MY_ACCOUNT, ":").concat(myListHeading, ":").concat(NEWEST_TO_OLDEST),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(constant_MY_ACCOUNT, ":").concat(myListHeading, ":").concat(LISTS)
    };
    pushToAdobeDataLayer(eventInfo);
};
const dataLayerOldestToNewest = (myListTitle, sortByTitle)=>{
    const myListHeading = myListTitle === null || myListTitle === void 0 ? void 0 : myListTitle.toLowerCase();
    const sortByHeading = sortByTitle === null || sortByTitle === void 0 ? void 0 : sortByTitle.toLowerCase();
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(constant_MY_ACCOUNT, ":").concat(myListHeading, ":").concat(LISTS, ":").concat(sortByHeading),
        eventMsg: "n/a",
        eventName: "".concat(constant_MY_ACCOUNT, ":").concat(myListHeading, ":").concat(LISTS, ":").concat(sortByHeading),
        eventStatus: "n/a",
        eventType: "".concat(MyList_constant_NAVIGATION),
        internalLinkName: "".concat(OLDEST_TO_NEWEST),
        internalLinkPosition: "".concat(constant_MY_ACCOUNT, ":").concat(myListHeading, ":").concat(LISTS),
        internalLinkType: "".concat(constant_MY_ACCOUNT, ":").concat(myListHeading, ":").concat(OLDEST_TO_NEWEST),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(constant_MY_ACCOUNT, ":").concat(myListHeading, ":").concat(LISTS)
    };
    pushToAdobeDataLayer(eventInfo);
};
const pushListDetailsAdobeDataLayer = (data)=>{
    const { name ="" , eventInfo ={} , productsCount =0 , productInfo =[]  } = data;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = (getState === null || getState === void 0 ? void 0 : getState("page")) || {};
    if (productInfo === null || productInfo === void 0 ? void 0 : productInfo.length) {
        page.productInfo = productInfo;
    }
    page.category.pageType = "".concat(MY_LISTS, ":").concat(name, ":").concat(productsCount);
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page
    });
};
const dataLayerEventDetailsPageProductInfo = (records, quantityObject)=>{
    return records.map((product)=>{
        const colorAndImage = {
            color: "",
            image: ""
        };
        if (product["Color.CTR.Details_ss"]) {
            const productInfoRec = product["Color.CTR.Details_ss"].filter((rec)=>{
                return product["masterSKU_s"] === rec.split("|")[0];
            });
            if (productInfoRec.length) {
                const values = productInfoRec[0].split("|");
                colorAndImage.color = values[1];
                colorAndImage.image = values[5];
            }
        }
        var ref, ref1, ref2, ref3, ref4, ref5, ref6;
        return {
            category: (ref = product["Product_Category"]) !== null && ref !== void 0 ? ref : "",
            description: (ref1 = product["ProductDescriptionProductShort_s"]) !== null && ref1 !== void 0 ? ref1 : "",
            productID: (ref2 = product["ctId_s"]) !== null && ref2 !== void 0 ? ref2 : "",
            productName: (ref3 = product["productName_s"]) !== null && ref3 !== void 0 ? ref3 : "",
            quantity: (ref4 = quantityObject[product["masterSKU_s"]]) !== null && ref4 !== void 0 ? ref4 : "",
            productSalePrice: (ref5 = product["priceList.CTR.finalPrice_d"]) !== null && ref5 !== void 0 ? ref5 : "",
            productSku: (ref6 = product["masterSKU_s"]) !== null && ref6 !== void 0 ? ref6 : "",
            defaultImageName: colorAndImage === null || colorAndImage === void 0 ? void 0 : colorAndImage.image,
            productColor: colorAndImage === null || colorAndImage === void 0 ? void 0 : colorAndImage.color
        };
    });
};
const dataLayerListDetailPageEvents = (data)=>{
    const { name ="" , actionType ="" , productsCount =0 , records =[] , quantityObject ={} , productName =""  } = data;
    let productInfo;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(constant_MY_ACCOUNT, ":").concat(MY_LISTS, ":").concat(actionType),
        eventMsg: "n/a",
        eventName: "".concat(constant_MY_ACCOUNT, ":").concat(MY_LISTS, ":").concat(actionType),
        eventStatus: "n/a",
        eventType: "".concat(MyList_constant_NAVIGATION),
        internalLinkName: actionType === "product navigation" ? "".concat(productName) : "".concat(actionType),
        internalLinkPosition: "".concat(constant_MY_ACCOUNT, ":").concat(MY_LISTS),
        internalLinkType: "".concat(constant_MY_ACCOUNT, ":").concat(MY_LISTS, ":").concat(name),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(constant_MY_ACCOUNT, ":").concat(MY_LISTS)
    };
    if (actionType === "load more products") {
        productInfo = dataLayerEventDetailsPageProductInfo(records, quantityObject);
    }
    pushListDetailsAdobeDataLayer({
        eventInfo,
        productsCount,
        productInfo,
        name
    });
};
const dataLayerEventDetailsPageShow = (data)=>{
    const { name ="" , listInfo ={} , quantityObject ={} , records =[]  } = data;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = (getState === null || getState === void 0 ? void 0 : getState("page")) || {};
    const productInfo = dataLayerEventDetailsPageProductInfo(records, quantityObject);
    page.category["pageType"] = "".concat(MY_LISTS, ":").concat(name, ":").concat(listInfo === null || listInfo === void 0 ? void 0 : listInfo.lineItemsCount);
    page.category["primaryCategory"] = "".concat(KOHLER, ":").concat(constant_MY_ACCOUNT);
    page.category["subCategory1"] = "".concat(constant_MY_ACCOUNT, ":").concat(MY_LISTS);
    page.category["subCategory2"] = "".concat(KOHLER, ":").concat(constant_MY_ACCOUNT, ":").concat(MY_LISTS, ":").concat(name);
    page.category["subCategoryID"] = "".concat(MY_LISTS, ":").concat(name);
    page.category["subCategoryName"] = "".concat(MY_LISTS, ":").concat(name);
    page.pageInfo["pageName"] = "".concat(KOHLER, ":").concat(constant_MY_ACCOUNT, ":").concat(MY_LISTS, ":").concat(name);
    page.pageInfo["previousPage"] = "".concat(KOHLER, ":").concat(constant_MY_ACCOUNT, ":").concat(ACCOUNT_SETTINGS);
    page.pageInfo["title"] = "My Lists | ".concat(name, " | KOHLER");
    page.listInfo = {
        ...listInfo
    };
    page.productInfo = productInfo;
    setTimeout(()=>{
        window.adobeDataLayer.splice(1, 1);
        window.adobeDataLayer.push({
            event: "cmp:show",
            page
        });
    }, 2500);
};

;// CONCATENATED MODULE: ./components/MyFavorites/v1/MyList/ListTile.jsx




















const ListTile = (props)=>{
    var ref, ref1, ref2, ref3;
    const { list ={} , presetConfigs ="" , setSelectedList =()=>{} , general ={}  } = props || {};
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const staticText = (0,localization/* getTranslations */.F)(t);
    const { globalConfig: { internationalization: { language ="en"  } = {}  } = {}  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const dispatch = (0,es/* useDispatch */.I0)();
    const [width] = (0,useWindowResize/* default */.Z)();
    const [listProductData, setListProductData] = (0,react.useState)({});
    const [images, setImages] = (0,react.useState)([]);
    const listNameRef = (0,react.useRef)(null);
    const [listNameTruncated, setListNameTruncated] = (0,react.useState)(false);
    const [locale, setLocale] = (0,react.useState)("");
    const [emptyListModalOpen, setEmptyListModalOpen] = (0,react.useState)(false);
    const [emptyList, setEmptyList] = (0,react.useState)(false);
    const [deleteList, setDeleteList] = (0,react.useState)(false);
    const [selectedListId, setSelectedListId] = (0,react.useState)("");
    const router = (0,next_router.useRouter)();
    const listLineItemsLength = list === null || list === void 0 ? void 0 : (ref = list.lineItems) === null || ref === void 0 ? void 0 : ref.length;
    const getListInfo = function() {
        let needsJSON = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        var ref, ref1, ref2;
        const listName = list === null || list === void 0 ? void 0 : list.name[locale];
        var ref3;
        const listInfo = {
            description: (0,helper/* sanitizeTextForAnalytics */.T68)((list === null || list === void 0 ? void 0 : list.description) ? list === null || list === void 0 ? void 0 : list.description[locale] : "") || "n/a",
            listID: (list === null || list === void 0 ? void 0 : list.id) || "n/a",
            listName: (0,helper/* sanitizeTextForAnalytics */.T68)(listName) || "n/a",
            lineItemsCount: (list === null || list === void 0 ? void 0 : (ref = list.lineItems) === null || ref === void 0 ? void 0 : ref.length) || 0,
            listUpdatedProject: "".concat((0,helper/* geMonthNameDayandYear */.NpZ)(list === null || list === void 0 ? void 0 : list.lastModifiedAt, locale)),
            listLocation: ((ref3 = list === null || list === void 0 ? void 0 : (ref1 = list.custom) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.fields) === null || ref2 === void 0 ? void 0 : ref2.project) !== null && ref3 !== void 0 ? ref3 : "") || "n/a"
        };
        if (needsJSON) {
            return listInfo.listInfo;
        }
        return JSON.stringify(listInfo);
    };
    const listInfo = JSON.parse(getListInfo(false));
    const handleListView = function(count) {
        let isFavImg = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, list = arguments.length > 2 ? arguments[2] : void 0;
        const myListTitle = staticText === null || staticText === void 0 ? void 0 : staticText.myListPageTitle;
        const viewListCTATitle = staticText === null || staticText === void 0 ? void 0 : staticText.viewList;
        const listName = list === null || list === void 0 ? void 0 : list.name[locale];
        const idView = "?listId=".concat(selectedListId);
        dataLayerViewListButton(myListTitle, viewListCTATitle, listName, listInfo, idView);
        if (!count) {
            setEmptyList(true);
            setEmptyListModalOpen(true);
        } else if (!isFavImg) {
            setSelectedList(selectedListId);
            router.push({
                pathname: "/".concat(language).concat(routes/* MY_LISTS_PAGE_PATH */.PN),
                query: {
                    listId: selectedListId
                }
            });
        }
    };
    const handleShopOurBestSellars = (count, list)=>{
        if (!count) {
            const myListTitle = staticText === null || staticText === void 0 ? void 0 : staticText.myListPageTitle;
            const shopBestSellerCTATitle = staticText === null || staticText === void 0 ? void 0 : staticText.shoupOurBestSellerListBtn;
            dataLayerShopBestSellerButton(myListTitle, shopBestSellerCTATitle, list === null || list === void 0 ? void 0 : list.name[locale], listInfo);
            router.push("/".concat(language).concat(routes/* PRODUCT_BEST_SELLERS */.RG)).then(()=>{
                router.reload();
            });
        } else {
            handleListView(count, false, list);
        }
    };
    const closeConformationModal = ()=>{
        setEmptyListModalOpen(false);
        setDeleteList(false);
        setEmptyList(false);
    };
    const handleListDelete = (list)=>{
        const myListTitle = staticText === null || staticText === void 0 ? void 0 : staticText.myListPageTitle;
        const deleteListTitle = staticText === null || staticText === void 0 ? void 0 : staticText.deleteList;
        dataLayerDeleteListButton(myListTitle, deleteListTitle, list === null || list === void 0 ? void 0 : list.name[locale], listInfo);
        setDeleteList(true);
        setEmptyListModalOpen(true);
    };
    const getListProductData = ()=>{
        dispatch((0,favoritesSlice/* getListFirstLineItemsData */.Vb)(list, false)).unwrap().then((response)=>{
            setListProductData(response);
            const images = getLineItemsProductImage(response[0]);
            setImages(images);
        }).catch((error)=>{
            console.log(error);
        });
    };
    (0,react.useEffect)(()=>{
        if (listLineItemsLength) {
            getListProductData();
        } else {
            setImages([
                "MissingImage"
            ]);
        }
        setSelectedListId(listLineItemsLength ? list === null || list === void 0 ? void 0 : list.id : "");
    }, [
        list,
        listLineItemsLength
    ]);
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>{
            const { internationalization: { locale ="en-US"  } = {}  } = config;
            const localeVAlue = locale === "fr-CA" ? "en-CA" : locale;
            setLocale(localeVAlue);
        });
    }, []);
    (0,react.useEffect)(()=>{
        const listNameEl = listNameRef.current;
        if (listNameEl) {
            setListNameTruncated((listNameEl === null || listNameEl === void 0 ? void 0 : listNameEl.scrollWidth) > (listNameEl === null || listNameEl === void 0 ? void 0 : listNameEl.clientWidth));
        }
    }, [
        list === null || list === void 0 ? void 0 : list.name[locale]
    ]);
    const noProcutsImageComponent = (id, i)=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
            id: id + "_IMG_" + i,
            src: No_Products_Yet,
            role: "presentation",
            alt: "Product image not available",
            onClick: ()=>{
                handleListView(listLineItemsLength);
            }
        }, id + "_IMG_" + i);
    };
    var ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "userListTile",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "listImage",
                onClick: ()=>{
                    handleListView(listLineItemsLength);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "product-image",
                    children: listLineItemsLength ? images.map((id, i)=>{
                        const imgUrl = (0,utils/* getPresetUrl */.v$)(width, 0, general.swatchUrl, id, JSON.parse(presetConfigs));
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            id: id + "_IMG_" + i,
                            role: "presentation",
                            src: imgUrl,
                            alt: listProductData.metaTitle_s,
                            imgsrc: imgUrl,
                            imgalt: listProductData.metaTitle_s,
                            onError: (e)=>(0,utils/* onImageError */.Ac)(e, imgUrl)
                        }, id + "_IMG_" + i);
                    }) : noProcutsImageComponent("missingImage", 0)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "listDetailsContainer",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "listDetails",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "listName",
                                onClick: ()=>{
                                    handleListView(listLineItemsLength);
                                },
                                ref: listNameRef,
                                children: [
                                    list === null || list === void 0 ? void 0 : list.name[locale],
                                    listNameTruncated ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "listNameToolTip",
                                        children: list === null || list === void 0 ? void 0 : list.name[locale]
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "listUpdatedProject",
                                children: "".concat(t("kf.myList.page.updated"), ": ").concat((0,helper/* geMonthNameDayandYear */.NpZ)(list === null || list === void 0 ? void 0 : list.lastModifiedAt, locale))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "listUpdatedProject",
                                children: (ref4 = list === null || list === void 0 ? void 0 : (ref1 = list.custom) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.fields) === null || ref2 === void 0 ? void 0 : ref2.project) !== null && ref4 !== void 0 ? ref4 : ""
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "countAndFavImage",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "favImage",
                                onClick: ()=>handleListView(listLineItemsLength, true),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    src: listLineItemsLength ? wishlist_gray_filled/* default */.Z === null || wishlist_gray_filled/* default */.Z === void 0 ? void 0 : wishlist_gray_filled/* default.src */.Z.src : wish/* default */.Z === null || wish/* default */.Z === void 0 ? void 0 : wish/* default.src */.Z.src,
                                    role: "presentation",
                                    alt: "close",
                                    width: "30",
                                    height: "30"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "lineItemsCount",
                                children: list === null || list === void 0 ? void 0 : (ref3 = list.lineItems) === null || ref3 === void 0 ? void 0 : ref3.length
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "listDiscription",
                children: (list === null || list === void 0 ? void 0 : list.description) ? list === null || list === void 0 ? void 0 : list.description[locale] : ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "viewListBtn",
                onClick: ()=>{
                    handleShopOurBestSellars(listLineItemsLength, list);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "viewListText",
                    children: listLineItemsLength ? staticText === null || staticText === void 0 ? void 0 : staticText.viewList : staticText === null || staticText === void 0 ? void 0 : staticText.shoupOurBestSellerListBtn
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "deleteList",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "deleteOuterContainer",
                    onClick: ()=>{
                        handleListDelete(list);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "deleteListText",
                        children: staticText === null || staticText === void 0 ? void 0 : staticText.deleteList
                    })
                })
            }),
            emptyListModalOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ListConfirmationModal/* default */.Z, {
                list: list,
                openConforMationModal: emptyListModalOpen,
                noLineItems: emptyList,
                deleteList: deleteList,
                closeConformationModal: closeConformationModal
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tileDevider"
            })
        ]
    });
};
/* harmony default export */ var MyList_ListTile = (ListTile);

// EXTERNAL MODULE: ./components/SaveToList/index.jsx
var SaveToList = __webpack_require__(4165);
;// CONCATENATED MODULE: ./components/MyFavorites/v1/MyList/EmptyListPage.jsx





const EmptyListPage = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const staticText = (0,localization/* getTranslations */.F)(t);
    const router = (0,next_router.useRouter)();
    const handleBestSellersBtn = ()=>{
        router.push(routes/* PRODUCT_BEST_SELLERS */.RG);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "userListEmptyContainer",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "userListEmptyText",
                children: staticText === null || staticText === void 0 ? void 0 : staticText.listPageEmptyText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bestSellersBtn",
                onClick: handleBestSellersBtn,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bestSellersBtnTxt",
                    children: staticText === null || staticText === void 0 ? void 0 : staticText.bestSellers
                })
            })
        ]
    });
};
/* harmony default export */ var MyList_EmptyListPage = (EmptyListPage);

// EXTERNAL MODULE: ./components/PartsViewer/v2/icon.js + 1 modules
var icon = __webpack_require__(7051);
// EXTERNAL MODULE: ./components/Loader/index.module.scss
var index_module = __webpack_require__(25443);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./components/Loader/index.jsx



const Loader = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).LoaderComponent,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "loader-image",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon/* LoaderSpinner */.cK, {})
        })
    });
};
/* harmony default export */ var components_Loader = (Loader);

// EXTERNAL MODULE: ./components/MyFavorites/v1/MyList/index.module.scss
var MyList_index_module = __webpack_require__(84267);
var MyList_index_module_default = /*#__PURE__*/__webpack_require__.n(MyList_index_module);
// EXTERNAL MODULE: ./components/core/Checkbox/Checkbox.jsx + 1 modules
var Checkbox = __webpack_require__(65764);
;// CONCATENATED MODULE: ./public/icons/edit-list.svg
/* harmony default export */ var edit_list = ({"src":"/_next/static/media/edit-list.2d2d9703.svg","height":30,"width":16});
// EXTERNAL MODULE: ./public/icons/back-top-arrow.svg
var back_top_arrow = __webpack_require__(12522);
// EXTERNAL MODULE: ./components/cart/QuantitySelector.jsx
var QuantitySelector = __webpack_require__(75653);
// EXTERNAL MODULE: ./components/Shared/DisplayDiscountPrice/index.jsx
var DisplayDiscountPrice = __webpack_require__(71025);
;// CONCATENATED MODULE: ./components/MyFavorites/v1/MyList/ColorSwatchSelected/v1/index.jsx

const ColorSwatchSelected = (props)=>{
    const { colors =[] , general ={} , cx ="" , mobile =false  } = props || {};
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        className: "color-swatch display-none".concat(mobile ? "__desktop" : ""),
        children: colors === null || colors === void 0 ? void 0 : colors.map((color, i)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                htmlFor: "".concat(color.name, "-id"),
                role: "radio",
                tabIndex: "0",
                "aria-label": "".concat(color.name, " color"),
                "aria-checked": true,
                rel: "noreferrer",
                title: color.name,
                className: cx({
                    "selected-swatch": true
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "radio",
                        id: "".concat(color.name, "-id"),
                        "aria-label": "".concat(color.name)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "swatch-outline",
                        role: "presentation",
                        src: "".concat(general.swatchUrl).concat(color.swatch).concat(window.innerWidth <= 768 ? "?$PLPSwatch_Mobile50$" : "?$PLPSwatch_Desk100$"),
                        width: "20px",
                        alt: color.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "color-text",
                        children: color.name
                    })
                ]
            }, "color-".concat(color.sku, "-").concat(color.customerFacingSKU, "-").concat(i)))
    });
};
/* harmony default export */ var v1 = (ColorSwatchSelected);

// EXTERNAL MODULE: ./public/images/image-missing.png
var image_missing = __webpack_require__(36513);
;// CONCATENATED MODULE: ./components/MyFavorites/v1/MyList/ListRowItems/v1/ListRowItems.jsx














const ListRowItem = (props)=>{
    var ref, ref1;
    const { general , siteName , productQtyObj , qtyChange , product , presetConfigs , handleCheckBoxChecked , checkedItems , handleProductView , listItemsPrice  } = props;
    const { "productImages.url_ss": imageUrl , ProductBrandName_s: brandName , masterSKU_s: sku , ProductDescriptionProductShort_s: shortDescription  } = product;
    const [tileUrl, setTileUrl] = (0,react.useState)("");
    const handleImageClick = (e)=>{
        if (e.target.className && e.target.className !== "checkbox__marker-icon") {
            e.stopPropagation();
            e.preventDefault();
            handleProductView(brandName);
            location.href = decodeURIComponent("".concat(tileUrl, "?skuId=").concat(sku));
        }
    };
    const handleProductNameClick = ()=>{
        handleProductView(brandName);
        location.href = decodeURIComponent("".concat(tileUrl, "?skuId=").concat(sku));
    };
    (0,react.useEffect)(()=>{
        var _ProductLocalCategory_s;
        const category = product.Product_Category ? product.Product_Category : (_ProductLocalCategory_s = product.ProductLocalCategory_s) !== null && _ProductLocalCategory_s !== void 0 ? _ProductLocalCategory_s : "";
        (0,helper/* getPDPUrl */.ir5)(category, product.slug_s).then((ret)=>setTileUrl(ret));
    }, [
        product
    ]);
    const [width] = (0,useWindowResize/* default */.Z)();
    const colors = getColors(product);
    const images = getLineItemsProductImage(product);
    var ref2, _sku;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "row list-item no-gutters",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-12 col-sm-6 mobile-full-width col-md-6 list-left ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "list-item__summary",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            role: "button",
                            onClick: (e)=>handleImageClick(e),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "list-image-tile",
                                children: [
                                    (imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl[0]) && (images === null || images === void 0 ? void 0 : images.length) > 0 ? images === null || images === void 0 ? void 0 : images.map((id, i)=>{
                                        const imgUrl = (0,utils/* getPresetUrl */.v$)(width, 0, general.swatchUrl, id, JSON.parse(presetConfigs));
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            className: "list-image",
                                            id: id + "_IMG_" + i,
                                            role: "presentation",
                                            src: imgUrl,
                                            imgsrc: imgUrl
                                        }, id + "_IMG_" + i);
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        className: "list-image",
                                        src: image_missing/* default */.Z,
                                        alt: "missing-image"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "checkbox-on-tile",
                                        "data-id": product["masterSKU_s"],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                            onChange: (e)=>handleCheckBoxChecked(e, product["masterSKU_s"]),
                                            checked: checkedItems.includes(product["masterSKU_s"])
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            className: "list-item__specs list-item__specs-tabs",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "row no-gutters",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-12 list-item-desc__name",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "".concat(colors && ((ref = colors[0]) === null || ref === void 0 ? void 0 : ref.name) === "Not Applicable" ? "visibilty" : ""),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1, {
                                                colors: colors,
                                                cx: (classnames_default()),
                                                general: general,
                                                mobile: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "list-item__brand__list",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "list-item__brand-name",
                                                children: siteName === null || siteName === void 0 ? void 0 : siteName.toUpperCase()
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "list-item__list-name",
                                            onClick: handleProductNameClick,
                                            children: brandName
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "list-product-description-short",
                                            children: shortDescription
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "list-product-description-short-sku",
                                            children: sku
                                        }),
                                        colors && ((ref1 = colors[0]) === null || ref1 === void 0 ? void 0 : ref1.name) === "Not Applicable" ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(v1, {
                                            colors: colors,
                                            cx: (classnames_default()),
                                            general: general,
                                            mobile: false
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-12 col-sm-6 col-md-6 list-item__info print-right",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row list-item__qty-price cart-qty-price-mobile mx-0 px-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-4 list-item__discount-container discount-container-padding ",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "list-item__price",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "list-details-price hide-mobile-price",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayDiscountPrice/* default */.Z, {
                                        formListDetails: true,
                                        price: listItemsPrice[sku],
                                        discountedPrice: listItemsPrice[(ref2 = "".concat(sku, "-discount")) !== null && ref2 !== void 0 ? ref2 : ""]
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-4 list-item__qty px-1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "quantity-selector no-print small",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantitySelector/* default */.Z, {
                                    size: "small",
                                    value: (_sku = productQtyObj[sku]) !== null && _sku !== void 0 ? _sku : 1,
                                    onChange: (value)=>qtyChange(value, product)
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-4 text-right list-item__total px-0 hide-price-popup-mobile ",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "list-details-price hide-mobile-price",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayDiscountPrice/* default */.Z, {
                                    price: getProductPrice(product, productQtyObj, listItemsPrice)
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var ListRowItems = (ListRowItem);

;// CONCATENATED MODULE: ./components/MyFavorites/v1/MyList/ListDetails.jsx


























const ListDetails = (props)=>{
    const { list ={} , siteName ="" , setSelectedList =()=>{} , deleteListSuccess =()=>{} , setIsListDetailsPage =()=>{} , presetConfigs =""  } = props;
    const { access_token: accessToken  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const staticText = (0,localization/* getTranslations */.F)(t);
    const router = (0,next_router.useRouter)();
    const { edit , moveItems , deleteItems , deleteList , itemPrice , quantity , total , item , listTotal , browseMoreProducts , selectAll , created , backToTop , editList  } = staticText;
    const { globalConfig  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { general ={
        swatchUrl: constants["default"] === null || constants["default"] === void 0 ? void 0 : constants["default"].COLOR_FILE_URL,
        siteName: constants.EXCEPTIONAL_SITENAME.charAt(0).toUpperCase() + constants.EXCEPTIONAL_SITENAME.slice(1)
    } , internationalization: { locale: configLocal = "" , language ="en" , currencyCode =""  } = {}  } = globalConfig;
    const locale = configLocal === "fr-CA" ? "en-CA" : configLocal;
    const currentList = list[0];
    const { name ="" , description ="" , custom: { fields: { project  } = {}  } = {}  } = currentList || {};
    const [checkedItems, setCheckedItem] = (0,react.useState)([]);
    const [nameValue, setNameValue] = (0,react.useState)(name[locale]);
    const [descriptionValue, setDescriptionValue] = (0,react.useState)(description[locale]);
    const [projectValue, setProjectValue] = (0,react.useState)(project);
    const [productData, setProductData] = (0,react.useState)([]);
    const [allProductsData, setAllProductsData] = (0,react.useState)([]);
    const [baseData, setBaseData] = (0,react.useState)([]);
    const [productQtyObj, setProductQtyObj] = (0,react.useState)({});
    const [openForm, setOpenForm] = (0,react.useState)(false);
    const [openConforMationModal, setOpenConfirmationModal] = (0,react.useState)(false);
    const [deletList, setDeleteList] = (0,react.useState)(false);
    const [emptyList, setEmptyList] = (0,react.useState)(false);
    const [showLoader, setShowLoader] = (0,react.useState)(false);
    const [currentListVal, setCurrentListVal] = (0,react.useState)({});
    const [openMoveToList, setOpenMoveToList] = (0,react.useState)(false);
    const [selectAllCheckBoxChecked, setSelectAllCheckBoxChecked] = (0,react.useState)(false);
    const [openMultiItemsDeleteFromList, setOpenMultiItemsDeleteFromList] = (0,react.useState)(false);
    const [persona, setPersona] = (0,react.useState)("");
    const [listItemsPrice, setListItemsPrice] = (0,react.useState)({});
    const dispatch = (0,es/* useDispatch */.I0)();
    const handleBrowseMoreProducts = ()=>{
        dataLayerListDetailPageEvents({
            name: name[locale],
            actionType: "browse more products",
            productsCount: baseData.length
        });
        router.push("/".concat(language).concat(routes/* PRODUCT_BEST_SELLERS */.RG)).then(()=>{
            router.reload();
        });
    };
    const handleMoveSuccessCallBack = (responseData)=>{
        var ref;
        if (responseData === null || responseData === void 0 ? void 0 : (ref = responseData.deleteResponse) === null || ref === void 0 ? void 0 : ref.lineItems.length) {
            var ref1;
            setCurrentListVal({
                ...currentListVal,
                version: responseData === null || responseData === void 0 ? void 0 : (ref1 = responseData.deleteResponse) === null || ref1 === void 0 ? void 0 : ref1.version
            });
            getListDetails(responseData === null || responseData === void 0 ? void 0 : responseData.deleteResponse);
            setSelectAllCheckBoxChecked(false);
            setCheckedItem([]);
        } else {
            deleteListSuccess();
        }
    };
    const handleCheckBoxChecked = (e, id)=>{
        if (e.target.checked) {
            setCheckedItem([
                ...checkedItems,
                id
            ]);
        } else {
            const items = checkedItems.filter((pid)=>pid !== id);
            setCheckedItem(items);
            if (!items.length) {
                setSelectAllCheckBoxChecked(false);
            }
        }
    };
    const handleDataLayerShow = (currentList, records, quantityObject)=>{
        const { description ={} , name ={} , lineItems =[] , id ="n/a" , lastModifiedAt ="" , custom: { fields: { project =""  } = {}  } = {}  } = currentList;
        var _locale;
        const listInfo = {
            description: (0,helper/* sanitizeTextForAnalytics */.T68)((_locale = description[locale]) !== null && _locale !== void 0 ? _locale : "") || "n/a",
            listID: id !== null && id !== void 0 ? id : "n/a",
            listName: (0,helper/* sanitizeTextForAnalytics */.T68)(name[locale]) || "n/a",
            lineItemsCount: lineItems.length,
            listUpdatedProject: "".concat((0,helper/* geMonthNameDayandYear */.NpZ)(lastModifiedAt, locale)),
            listLocation: (project !== null && project !== void 0 ? project : "") || "n/a"
        };
        dataLayerEventDetailsPageShow({
            name: name[locale],
            listInfo,
            records,
            quantityObject
        });
    };
    const handleCheckBoxAllClick = (e)=>{
        if (e.target.checked) {
            setCheckedItem(productData.map((product)=>{
                return product["masterSKU_s"];
            }));
            setSelectAllCheckBoxChecked(true);
        } else {
            setSelectAllCheckBoxChecked(false);
            setCheckedItem([]);
        }
    };
    const closeMultiItemsDeleteFromList = (listResponse)=>{
        setOpenMultiItemsDeleteFromList(false);
        if (listResponse === null || listResponse === void 0 ? void 0 : listResponse.lineItems.length) {
            setCurrentListVal({
                ...currentListVal,
                version: listResponse === null || listResponse === void 0 ? void 0 : listResponse.version
            });
            getListDetails(listResponse);
            setSelectAllCheckBoxChecked(false);
            setCheckedItem([]);
        } else {
            deleteListSuccess();
        }
    };
    const handleProductView = (productName)=>{
        dataLayerListDetailPageEvents({
            name: name[locale],
            actionType: "product navigation",
            productsCount: baseData.length,
            productName
        });
    };
    const handleLoadMoreProducts = ()=>{
        const nextrecords = productData.length + 10;
        if (nextrecords < baseData.length) {
            const records = baseData.slice(0, nextrecords);
            dataLayerListDetailPageEvents({
                name: name[locale],
                actionType: "load more products",
                productsCount: baseData.length,
                records,
                quantityObject: productQtyObj
            });
            setProductData(records);
            setAllProductsData(baseData.slice(nextrecords));
        } else {
            const remainingRecords = baseData.slice(productData.length);
            const records1 = [
                ...productData,
                ...remainingRecords
            ];
            dataLayerListDetailPageEvents({
                name: name[locale],
                actionType: "load more products",
                productsCount: baseData.length,
                records: records1,
                quantityObject: productQtyObj
            });
            setProductData(records1);
            setAllProductsData([]);
        }
    };
    const getListDetails = (currentList)=>{
        window.scrollTo(0, 0);
        setCurrentListVal(currentList);
        setShowLoader(true);
        dispatch((0,favoritesSlice/* getListFirstLineItemsData */.Vb)(currentList, true)).unwrap().then((response)=>{
            const qtObject = {};
            const refinedResponse = [];
            currentList === null || currentList === void 0 ? void 0 : currentList.lineItems.forEach(async (lineItem)=>{
                var ref, ref1;
                qtObject[lineItem === null || lineItem === void 0 ? void 0 : (ref = lineItem.variant) === null || ref === void 0 ? void 0 : ref.sku] = lineItem === null || lineItem === void 0 ? void 0 : lineItem.quantity;
                const productInfo = response.filter((rec)=>{
                    return rec["ctId_s"] === (lineItem === null || lineItem === void 0 ? void 0 : lineItem.productId);
                });
                const sku = lineItem === null || lineItem === void 0 ? void 0 : (ref1 = lineItem.variant) === null || ref1 === void 0 ? void 0 : ref1.sku;
                refinedResponse.push({
                    ...productInfo[0],
                    masterSKU_s: sku
                });
            });
            setProductQtyObj(qtObject);
            setBaseData(refinedResponse);
            if (refinedResponse.length > 10) {
                const records = refinedResponse.slice(0, 10);
                setProductData(records);
                setAllProductsData(refinedResponse.slice(10));
                handleDataLayerShow(currentList, records, qtObject);
            } else {
                setProductData(refinedResponse);
                handleDataLayerShow(currentList, refinedResponse, qtObject);
            }
            setShowLoader(false);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.log(error);
            setShowLoader(false);
        });
        setIsListDetailsPage(true);
    };
    const getSkuPrice = async (baseData)=>{
        const skuPrices = baseData.map((obj)=>{
            const payload = {
                slug: obj["slug_s"],
                sku: obj["masterSKU_s"],
                currencyCode,
                persona
            };
            return dispatch((0,favoritesSlice/* getProductBySlug */.Co)(payload)).unwrap();
        });
        try {
            const results = await Promise.all(skuPrices);
            const listItemsPrice = results.reduce((acc, obj)=>{
                return {
                    ...acc,
                    ...obj
                };
            }, {});
            setListItemsPrice(listItemsPrice);
        } catch (error) {
            console.log(error);
        }
    };
    (0,react.useEffect)(()=>{
        if (baseData.length) getSkuPrice(baseData);
    }, [
        baseData
    ]);
    (0,react.useEffect)(()=>{
        if (accessToken) {
            setPersona((0,helper/* getUserPersona */.shu)());
        }
    }, [
        accessToken
    ]);
    (0,react.useEffect)(()=>{
        getListDetails(currentList);
        return ()=>{
            setIsListDetailsPage(false);
        };
    }, []);
    (0,react.useEffect)(()=>{
        if (baseData.length > 10) {
            setProductData(baseData.slice(0, 10));
            setAllProductsData(baseData.slice(10));
        } else {
            setProductData(baseData);
        }
    }, [
        baseData
    ]);
    const qtyChange = async (qty, product, list)=>{
        var ref, ref1;
        const { updatedQuantity =1 , actionType =""  } = listItemQuantityChangeTypeAndValueCal(qty, product, productQtyObj);
        if (!actionType) {
            return;
        }
        setShowLoader(true);
        const lineItems = (ref = list[0]) === null || ref === void 0 ? void 0 : ref.lineItems;
        const lineItem = lineItems === null || lineItems === void 0 ? void 0 : lineItems.filter((item)=>{
            var ref;
            return (item === null || item === void 0 ? void 0 : (ref = item.variant) === null || ref === void 0 ? void 0 : ref.sku) === product["masterSKU_s"];
        });
        dispatch((0,favoritesSlice/* addListLineItemQuantity */.kn)({
            listId: currentListVal === null || currentListVal === void 0 ? void 0 : currentListVal.id,
            version: currentListVal === null || currentListVal === void 0 ? void 0 : currentListVal.version,
            productId: product["ctId_s"],
            quantity: updatedQuantity,
            lineItemId: lineItem[0].id,
            variantId: (ref1 = lineItem[0]) === null || ref1 === void 0 ? void 0 : ref1.variantId,
            action: actionType
        })).unwrap().then((response)=>{
            var ref, ref1;
            setCurrentListVal({
                ...currentListVal,
                version: response === null || response === void 0 ? void 0 : response.version
            });
            const lineItem = response === null || response === void 0 ? void 0 : (ref = response.lineItems) === null || ref === void 0 ? void 0 : ref.filter((item)=>{
                var ref;
                return (item === null || item === void 0 ? void 0 : (ref = item.variant) === null || ref === void 0 ? void 0 : ref.sku) === product["masterSKU_s"];
            });
            const obj = {
                ...productQtyObj
            };
            obj[product["masterSKU_s"]] = (ref1 = lineItem[0]) === null || ref1 === void 0 ? void 0 : ref1.quantity;
            setProductQtyObj(obj);
            setShowLoader(false);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.log(error);
            const obj = {
                ...productQtyObj
            };
            setProductQtyObj(obj);
            setShowLoader(false);
        });
    };
    const handleBackToTop = ()=>{
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    const closeModalWithOutDelete = ()=>{
        setOpenConfirmationModal(false);
        setDeleteList(false);
        setEmptyList(false);
    };
    const successCallBack = (response)=>{
        var ref, ref1;
        setCurrentListVal({
            ...currentListVal,
            version: response.version
        });
        setNameValue(response.name[locale]);
        setDescriptionValue(response === null || response === void 0 ? void 0 : response.description[locale]);
        setProjectValue(response === null || response === void 0 ? void 0 : (ref = response.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.project);
        setOpenForm(false);
    };
    const handleEditList = ()=>{
        dataLayerListDetailPageEvents({
            name: name[locale],
            actionType: "edit",
            productsCount: baseData.length
        });
        setOpenForm(true);
    };
    const handleDeleteList = ()=>{
        var ref;
        setOpenConfirmationModal(true);
        setDeleteList(true);
        setEmptyList((list === null || list === void 0 ? void 0 : (ref = list.lineItems) === null || ref === void 0 ? void 0 : ref.length) > 0);
        dataLayerListDetailPageEvents({
            name: name[locale],
            actionType: "delete",
            productsCount: baseData.length
        });
    };
    const handleMoveItems = ()=>{
        setOpenMoveToList(true);
        dataLayerListDetailPageEvents({
            name: name[locale],
            actionType: "move items",
            productsCount: baseData.length
        });
    };
    const handleDeleteItems = ()=>{
        setOpenMultiItemsDeleteFromList(true);
        dataLayerListDetailPageEvents({
            name: name[locale],
            actionType: "delete items",
            productsCount: baseData.length
        });
    };
    const closeConfirmationModal = ()=>{
        setOpenConfirmationModal(false);
        setDeleteList(false);
        setEmptyList(false);
        deleteListSuccess();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (MyList_index_module_default()).ListDetailsWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "list-title",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "list-title-left",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "listName",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "list-name-box",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: nameValue
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "edit-box",
                                            onClick: handleEditList,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                    src: edit_list,
                                                    alt: "edit icon image"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "edit-text",
                                                    children: edit
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "listDescription",
                                children: descriptionValue
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "created-at-text",
                                children: [
                                    created,
                                    ": ",
                                    getFormattedDate(currentList)
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "created-at-text",
                                children: projectValue
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "list-title-right",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "delete-list-cta",
                            onClick: handleDeleteList,
                            children: deleteList
                        })
                    })
                ]
            }),
            (productData === null || productData === void 0 ? void 0 : productData.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "list-select-all-move-items-delete-items",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "select-all-box",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "select-all-checkbox",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                            onChange: handleCheckBoxAllClick,
                                            checked: selectAllCheckBoxChecked
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "select-all-text",
                                        children: selectAll
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "move-items-delete-items-box",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        role: "button",
                                        size: "small",
                                        flexible: true,
                                        type: "ghost",
                                        disabled: (checkedItems === null || checkedItems === void 0 ? void 0 : checkedItems.length) ? false : true,
                                        label: moveItems,
                                        onClick: handleMoveItems
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        role: "button",
                                        size: "small",
                                        flexible: true,
                                        type: "ghost",
                                        disabled: (checkedItems === null || checkedItems === void 0 ? void 0 : checkedItems.length) ? false : true,
                                        label: deleteItems,
                                        onClick: handleDeleteItems
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "list-landing",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "list-grid",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "row cart-items__th no-gutters ".concat((productData === null || productData === void 0 ? void 0 : productData.length) > 0 ? "cart-table-header-list display-none" : ""),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-4 d-none d-sm-block text-left cart-items__td px-0 col-md-6 display-none",
                                                "aria-hidden": "true",
                                                children: item
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-12 col-sm-6 col-md-6",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "row mx-0 px-0",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "col-4 d-none d-sm-block cart-items__td cart-td-unit-price display-none",
                                                            "aria-hidden": "true",
                                                            children: itemPrice
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "col-4 d-none d-sm-block text-center cart-items__td px-0 display-none",
                                                            "aria-hidden": "true",
                                                            children: quantity
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "col-4 d-none d-sm-block text-right cart-items__td px-0 display-none",
                                                            "aria-hidden": "true",
                                                            children: total
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    (productData === null || productData === void 0 ? void 0 : productData.length) > 0 ? productData.map((product, index)=>{
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListRowItems, {
                                            presetConfigs: presetConfigs,
                                            product: product,
                                            general: general,
                                            persona: persona,
                                            siteName: siteName,
                                            productQtyObj: productQtyObj,
                                            checkedItems: checkedItems,
                                            list: list[0],
                                            listItemsPrice: listItemsPrice,
                                            handleCheckBoxChecked: handleCheckBoxChecked,
                                            qtyChange: (qty, product)=>{
                                                qtyChange(qty, product, list);
                                            },
                                            handleProductView: handleProductView
                                        }, index);
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "list-footer",
                                style: {
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "space-between"
                                },
                                children: [
                                    window.innerWidth > 812 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "list-browse-more-text",
                                        onClick: handleBrowseMoreProducts,
                                        children: browseMoreProducts
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "list-total-text display-none",
                                        children: [
                                            listTotal,
                                            ":",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                style: {
                                                    paddingLeft: "20px"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                    value: getListTotalPrice(baseData, productQtyObj, listItemsPrice),
                                                    displayType: "text",
                                                    thousandSeparator: true,
                                                    prefix: "$",
                                                    decimalScale: 2,
                                                    fixedDecimalScale: true
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            allProductsData.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "load-more-button",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    label: "Load More",
                                    role: "button",
                                    size: "small",
                                    flexible: true,
                                    type: "ghost",
                                    onClick: handleLoadMoreProducts
                                })
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "list-back-to-top",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    role: "link",
                                    className: "go-back-button",
                                    onClick: handleBackToTop,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "go-back-text",
                                            children: backToTop
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            className: "go-back-image",
                                            "aria-hidden": "true",
                                            src: back_top_arrow/* default */.Z === null || back_top_arrow/* default */.Z === void 0 ? void 0 : back_top_arrow/* default.src */.Z.src,
                                            alt: backToTop
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }) : null,
            openForm ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SaveToList/* default */.Z, {
                showListSaveAndCreate: true,
                createList: true,
                listSaveAndCreateClose: ()=>{
                    setOpenForm(false);
                },
                listData: {
                    name: nameValue,
                    description: descriptionValue,
                    project: projectValue
                },
                editListText: editList,
                selectedListDetails: list,
                handleSuccessCallBack: successCallBack
            }) : null,
            openConforMationModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ListConfirmationModal/* default */.Z, {
                list: currentListVal,
                openConforMationModal: openConforMationModal,
                noLineItems: emptyList,
                deletefromListDetails: deletList,
                closeConformationModal: closeConfirmationModal,
                setSelectedList: setSelectedList,
                closeModalWithOutDelete: closeModalWithOutDelete
            }) : null,
            showLoader ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Loader, {}) : null,
            openMoveToList ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SaveToList/* default */.Z, {
                showListSaveAndCreate: true,
                moveToList: true,
                listSaveAndCreateClose: ()=>{
                    setOpenMoveToList(false);
                },
                moveOrDeleteFromListName: nameValue,
                currentList: currentListVal,
                productData: productData,
                productQtyObj: productQtyObj,
                selectedItems: checkedItems,
                handleSuccessCallBack: handleMoveSuccessCallBack
            }) : null,
            openMultiItemsDeleteFromList ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ListConfirmationModal/* default */.Z, {
                list: currentListVal,
                openConforMationModal: openMultiItemsDeleteFromList,
                selectedItems: checkedItems,
                multiDeleteFromList: true,
                listName: nameValue,
                handleSuccessCallBack: closeMultiItemsDeleteFromList,
                closeModalWithOutDelete: ()=>{
                    setOpenMultiItemsDeleteFromList(false);
                }
            }) : null
        ]
    });
};
/* harmony default export */ var MyList_ListDetails = (ListDetails);

;// CONCATENATED MODULE: ./components/MyFavorites/v1/MyList/index.jsx

















const MyLists = (props)=>{
    const { tabList =[] , presetConfigs ="" , sorts =[] , tabChange =()=>{} , openCreateNewList =false , createNewListCallBAck =()=>{} , siteName ="" , query ={} , setIsListDetailsPage =()=>{}  } = props || {};
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const router = (0,next_router.useRouter)();
    const dispatch = (0,es/* useDispatch */.I0)();
    const staticText = (0,localization/* getTranslations */.F)(t);
    const [selectedSort, setSelectedSort] = (0,react.useState)(sorts[0]);
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    const [userLists, setUserLists] = (0,react.useState)([]);
    const [openCreateNewModal, setOpenCreateNewModal] = (0,react.useState)(false);
    const [selectedList, setSelectedList] = (0,react.useState)(null);
    const [hasListIdInUrlParams, setHasListIdInUrlParams] = (0,react.useState)(false);
    const { globalConfig: { general ={
        swatchUrl: constants["default"] === null || constants["default"] === void 0 ? void 0 : constants["default"].COLOR_FILE_URL,
        siteName: constants.EXCEPTIONAL_SITENAME.charAt(0).toUpperCase() + constants.EXCEPTIONAL_SITENAME.slice(1)
    } , internationalization: { language =""  } = {}  } = {}  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const filteredList = userLists.filter((list)=>list.id === selectedList);
    (0,react.useEffect)(()=>{
        if (query === null || query === void 0 ? void 0 : query.listId) {
            var ref;
            const selectedList = userLists.filter((list)=>{
                return list.id === (query === null || query === void 0 ? void 0 : query.listId);
            });
            if (selectedList.length && ((ref = selectedList[0]) === null || ref === void 0 ? void 0 : ref.lineItems.length)) {
                setHasListIdInUrlParams(true);
                setSelectedList(query === null || query === void 0 ? void 0 : query.listId);
                router.replace({
                    pathname: "/".concat(language).concat(constants.MY_ACCOUNT_PATH, "/").concat(query === null || query === void 0 ? void 0 : query.slug[0]),
                    query: {
                        listId: query === null || query === void 0 ? void 0 : query.listId
                    }
                });
            } else {
                router.push("/".concat(language).concat(constants.MY_ACCOUNT_PATH, "/").concat(query === null || query === void 0 ? void 0 : query.slug[0]));
            }
        } else {
            setHasListIdInUrlParams(false);
            setSelectedList(null);
        }
    }, [
        query === null || query === void 0 ? void 0 : query.listId,
        userLists.length
    ]);
    (0,react.useEffect)(()=>{
        localStorage.setItem("userListsLength", userLists.length);
    }, [
        userLists.length
    ]);
    const handleListDeleteSuccess = ()=>{
        setHasListIdInUrlParams(false);
        setSelectedList(null);
        router.replace("/".concat(language).concat(routes/* MY_LISTS_PAGE_PATH */.PN)).then(()=>{
            dispatch((0,favoritesSlice/* getMyAccountListsWithLineItems */.WQ)());
        });
    };
    const handleSort = (sortType)=>{
        const myListTitle = staticText === null || staticText === void 0 ? void 0 : staticText.myListPageTitle;
        const sortTextTitle = staticText === null || staticText === void 0 ? void 0 : staticText.sortBy.replace(":", "");
        (sortType === null || sortType === void 0 ? void 0 : sortType.query) === "new" ? dataLayerNewestToOldest(myListTitle, sortTextTitle) : dataLayerOldestToNewest(myListTitle, sortTextTitle);
        setSelectedSort(sortType);
        (sortType === null || sortType === void 0 ? void 0 : sortType.query) === "new" ? setUserLists(userLists.slice().sort((a, b)=>{
            return new Date(b === null || b === void 0 ? void 0 : b.lastModifiedAt) - new Date(a === null || a === void 0 ? void 0 : a.lastModifiedAt);
        })) : setUserLists(userLists.slice().sort((a, b)=>{
            return new Date(a === null || a === void 0 ? void 0 : a.lastModifiedAt) - new Date(b === null || b === void 0 ? void 0 : b.lastModifiedAt);
        }));
    };
    const handleCreateNewList = ()=>{
        const myListTitle = staticText === null || staticText === void 0 ? void 0 : staticText.myListPageTitle;
        const createNewListTitle = staticText === null || staticText === void 0 ? void 0 : staticText.createList;
        setOpenCreateNewModal(true);
        dataLayerCreateNewMyListButton(myListTitle, createNewListTitle);
    };
    const handleCloseCreateNewList = ()=>{
        setOpenCreateNewModal(false);
        if (openCreateNewList) createNewListCallBAck(false);
    };
    const createNewListHandler = (newList)=>{
        (selectedSort === null || selectedSort === void 0 ? void 0 : selectedSort.query) === "new" ? setUserLists([
            newList,
            ...userLists
        ]) : setUserLists([
            ...userLists,
            newList
        ]);
        if (openCreateNewList) createNewListCallBAck(false);
    };
    const handleTabChange = (tabIndex)=>{
        tabChange(tabIndex);
    };
    (0,react.useEffect)(()=>{
        if (openCreateNewList) {
            setOpenCreateNewModal(true);
        }
    }, [
        openCreateNewList
    ]);
    (0,react.useEffect)(()=>{
        var ref;
        if ((ref = tabList[0]) === null || ref === void 0 ? void 0 : ref.data.length) {
            var ref1, ref2;
            setUserLists((ref1 = tabList[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : ref2.slice().sort((a, b)=>{
                return new Date(b === null || b === void 0 ? void 0 : b.lastModifiedAt) - new Date(a === null || a === void 0 ? void 0 : a.lastModifiedAt);
            }));
        }
    }, [
        tabList
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            selectedList && hasListIdInUrlParams ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MyList_ListDetails, {
                setIsListDetailsPage: setIsListDetailsPage,
                siteName: siteName,
                selectedId: selectedList,
                list: filteredList,
                hasListIdInUrlParams: hasListIdInUrlParams,
                setSelectedList: setSelectedList,
                deleteListSuccess: handleListDeleteSuccess,
                presetConfigs: presetConfigs
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container myListsWrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "myListHeader",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "myListHeaderText",
                                children: staticText === null || staticText === void 0 ? void 0 : staticText.myListPageTitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "myListCreateNew",
                                onClick: handleCreateNewList,
                                children: staticText === null || staticText === void 0 ? void 0 : staticText.createList
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "myListTabNamesContainer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "myListTabNames",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tabItem tabItemActive",
                                    onClick: ()=>{
                                        handleTabChange(0);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "tabNameText",
                                        children: staticText === null || staticText === void 0 ? void 0 : staticText.tablTitle
                                    })
                                }),
                                tabList.length > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tabItem",
                                    onClick: ()=>{
                                        handleTabChange(1);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "tabNameText",
                                        children: staticText === null || staticText === void 0 ? void 0 : staticText.tablTitleMedia
                                    })
                                }) : null
                            ]
                        })
                    }),
                    userLists.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "sortContainer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "sortItem",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Sort/* default */.Z, {
                                tabIndex: 0,
                                page: "favorites",
                                selectedtab: "0",
                                data: sorts,
                                texts: {
                                    sort: staticText === null || staticText === void 0 ? void 0 : staticText.sortBy
                                },
                                onChange: handleSort,
                                isOpen: isOpen,
                                setIsOpen: setIsOpen,
                                selectedSort: selectedSort,
                                isMyFavoriteTab: true,
                                isMyList: true
                            })
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "createNewAndSort",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "createNewList",
                                onClick: handleCreateNewList,
                                children: staticText === null || staticText === void 0 ? void 0 : staticText.createList
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "sortItem",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Sort/* default */.Z, {
                                    tabIndex: 0,
                                    page: "favorites",
                                    selectedtab: "0",
                                    data: sorts,
                                    texts: {
                                        sort: "Sort by:"
                                    },
                                    onChange: handleSort,
                                    isOpen: isOpen,
                                    setIsOpen: setIsOpen,
                                    selectedSort: selectedSort,
                                    isMyFavoriteTab: true
                                })
                            })
                        ]
                    }),
                    userLists.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_masonry_css_module, {
                        breakpointCols: constants.myListContainerBreakPoints,
                        className: "userListesConatiner",
                        columnClassName: "userListesConatinerColumn",
                        children: userLists.map((list, index)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MyList_ListTile, {
                                general: general,
                                list: list,
                                presetConfigs: presetConfigs,
                                setSelectedList: setSelectedList
                            }, list === null || list === void 0 ? void 0 : list.id);
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MyList_EmptyListPage, {})
                ]
            }),
            openCreateNewModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SaveToList/* default */.Z, {
                showListSaveAndCreate: openCreateNewModal,
                createList: true,
                listSaveAndCreateClose: handleCloseCreateNewList,
                handleSuccessCallBack: createNewListHandler
            }) : null
        ]
    });
};
/* harmony default export */ var MyList = (MyLists);

;// CONCATENATED MODULE: ./public/icons/edit.svg
/* harmony default export */ var edit = ({"src":"/_next/static/media/edit.3743e0da.svg","height":16,"width":16});
;// CONCATENATED MODULE: ./public/icons/close-favorite.svg
/* harmony default export */ var close_favorite = ({"src":"/_next/static/media/close-favorite.045f5553.svg","height":17,"width":17});
;// CONCATENATED MODULE: ./components/MyFavorites/v1/Favorites.view.jsx






















const FavoritesView = (props)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    const { tabList =[] , staticTexts ={} , handleDelete =()=>{} , sorts =[] , editMode =false , handleEditMode =()=>{} , handleSelect =()=>{} , continueShopUrl ="" , selectedItems =[] , presetConfigs ="" , isAuth =false , user ={} , selectedCount =0 , isFavoritesLoading =false , logout =()=>{} , redirect =()=>{} , handleCheckAll =()=>{} , authoredContent ={} , handleSelectAll =()=>{} , selectedAll =false , isSelected =false , locale ="" , productsPerPage =[] , data =[] , selectedSortItem ={} , brandSwitcherItems , isSaveProductToList =false , siteName , ...restProps } = props || {};
    const { title  } = authoredContent;
    const { itemRemove ="" , itemCancel ="" , favoritesDeleteMssg ="" , favoriteDeleteTitle ="" , backToTop: staticTextsBackToTop = "" , loadMore ="" , ariaLabel: { selectedAll: staticTextsSelectedAll = "" , close ="" , remove: ariaLabelRemove = "" , manageSelected: ariaLabelManageSelected = "" , allTab ="" , tabs =""  } , ariaManageText ="" , manageText ="" , manageFavorites ="" , UnselectAll ="" , selectAll ="" , remove =""  } = staticTexts;
    const activeTabRef = (0,react.useRef)(null);
    const smartCrop = (0,useSmartCrop/* default */.Z)();
    const [activeTab, setActiveTab] = (0,react.useState)(0);
    const [showModal, setShowModal] = (0,react.useState)(false);
    const [rows, setRows] = (0,react.useState)(30);
    var ref10;
    const [tabData, setTabData] = (0,react.useState)(()=>{
        var ref, ref1;
        return (ref10 = (ref = tabList[activeTab]) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.slice(0, rows)) !== null && ref10 !== void 0 ? ref10 : [];
    });
    const [swatchCount, setSwatchCount] = (0,react.useState)(5);
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    const [selectedSort, setSelectedSort] = (0,react.useState)(selectedSortItem);
    const onResizeHandler = debounce_default()(()=>setSwatchCount((0,helper/* getSwatchCount */.m3S)()), 200);
    const [openCreateNewList, setOpenCreateNewList] = (0,react.useState)(false);
    const [isListDetailsPage, setIsListDetailsPage] = (0,react.useState)(false);
    const createNewlist = ()=>{
        setOpenCreateNewList(true);
    };
    (0,react.useEffect)(()=>{
        window.addEventListener("resize", onResizeHandler);
        return ()=>{
            window.removeEventListener("resize", onResizeHandler);
        };
    }, []);
    const openModal = ()=>{
        setShowModal(true);
    };
    const closeModal = ()=>{
        setShowModal(false);
    };
    const enableRemove = selectedCount >= 1;
    const manageSelected = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        var ref;
        const currentTabData = (ref = tabList[activeTab]) === null || ref === void 0 ? void 0 : ref.data;
        if (currentTabData !== undefined) {
            setTabData(currentTabData === null || currentTabData === void 0 ? void 0 : currentTabData.slice(0, rows));
        } else {
            var ref1;
            setActiveTab(0);
            setTabData((ref1 = tabList[0]) === null || ref1 === void 0 ? void 0 : ref1.data);
        }
    }, [
        tabList,
        activeTab,
        rows
    ]);
    const handleManageTool = ()=>{
        var ref;
        handleEditMode(!editMode);
        manageSelected === null || manageSelected === void 0 ? void 0 : (ref = manageSelected.current) === null || ref === void 0 ? void 0 : ref.focus();
        handleCheckAll();
    };
    const changeTab = (tab)=>{
        var ref;
        const myListTitle = staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.myLists;
        const tabName = (ref = tabList[tab]) === null || ref === void 0 ? void 0 : ref.title;
        setActiveTab(tab);
        if (activeTab !== tab) {
            handleCheckAll();
        }
        dataLayerlistTab(myListTitle, tabName);
    };
    (0,react.useEffect)(()=>{
        if (data) {
            handleSort(selectedSort);
        }
    }, [
        data,
        activeTab
    ]);
    const handleSort = (sortType)=>{
        var ref;
        const activeTabData = ((ref = tabList[activeTab]) === null || ref === void 0 ? void 0 : ref.data) || [];
        if ((sortType === null || sortType === void 0 ? void 0 : sortType.query) === "old") {
            var ref1;
            setTabData((ref1 = [
                ...activeTabData
            ]) === null || ref1 === void 0 ? void 0 : ref1.sort((a, b)=>new Date(a.addedAt) - new Date(b.addedAt)));
        } else {
            var ref2;
            setTabData((ref2 = [
                ...activeTabData
            ]) === null || ref2 === void 0 ? void 0 : ref2.sort((a, b)=>new Date(b.addedAt) - new Date(a.addedAt)));
        }
        setSelectedSort(sortType);
        (0,helper/* replaceSearchUrl */.CjH)("sort", sortType === null || sortType === void 0 ? void 0 : sortType.query);
        setIsOpen(false);
    };
    const getSelectedProductsAnalyticName = function(selectedProducts) {
        let isSelectDeSelectAll = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        let data = [];
        if (selectedProducts && (selectedProducts === null || selectedProducts === void 0 ? void 0 : selectedProducts.length)) {
            const selectedProductItems = isSelectDeSelectAll ? [
                ...tabData
            ] : tabData === null || tabData === void 0 ? void 0 : tabData.filter((obj)=>{
                return selectedProducts === null || selectedProducts === void 0 ? void 0 : selectedProducts.some((item)=>{
                    return (obj === null || obj === void 0 ? void 0 : obj.id) === ((item === null || item === void 0 ? void 0 : item.id) || item);
                });
            });
            data = selectedProductItems === null || selectedProductItems === void 0 ? void 0 : selectedProductItems.map((i)=>{
                var ref, ref1;
                return i === null || i === void 0 ? void 0 : (ref = i.productData) === null || ref === void 0 ? void 0 : (ref1 = ref.productName_s) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase();
            });
        }
        return (data === null || data === void 0 ? void 0 : data.length) ? data === null || data === void 0 ? void 0 : data.join("|") : "n/a";
    };
    const handleKeyPress = (e)=>{
        if (e.keyCode === 37 || e.keyCode === 39) {
            let tab;
            if (e.keyCode === 37) {
                tab = activeTab - 1;
            } else if (e.keyCode === 39) {
                tab = activeTab + 1;
            }
            if (tab < 0) tab = tabList.length - 1;
            if (tab >= tabList.length) tab = 0;
            document.getElementById("".concat(tabList[tab].title, "-tab")).focus();
        }
    };
    const handleBackToTop = ()=>{
        var ref, ref1;
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        (ref1 = activeTabRef === null || activeTabRef === void 0 ? void 0 : (ref = activeTabRef.current) === null || ref === void 0 ? void 0 : ref.childNodes[activeTab]) === null || ref1 === void 0 ? void 0 : ref1.focus();
    };
    const handleRows = (row)=>{
        var ref, ref1;
        setRows(row);
        setTabData((ref = tabList[activeTab]) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.slice(0, row));
    };
    const handleLoadMore = ()=>{
        var ref, ref1, ref2, ref3;
        setTabData((ref = tabList[activeTab]) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.slice(0, ((ref2 = tabList[activeTab]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.length) + rows));
    };
    const getEventInfo = (type)=>{
        var ref, ref1;
        const selectedTab = tabList[activeTab] ? (ref = tabList[activeTab]) === null || ref === void 0 ? void 0 : (ref1 = ref.title) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase() : "";
        return JSON.stringify({
            clickInternalLinks: "true",
            eventAction: "my account:favorites:".concat(selectedTab, ":").concat(type ? type + ":" : "", "close"),
            eventName: "my account:favorites:".concat(selectedTab, ":").concat(type ? type + ":" : "", "close"),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "close",
            internalLinkPosition: "favorites",
            internalLinkType: "my account:close",
            internalLinkURL: "n/a",
            internalLinkZoneName: "my account:favorites:".concat(selectedTab).concat(type ? ":" + type : "")
        });
    };
    const getSelectUnSelectEventInfo = (isSelected, tabData)=>{
        var ref, ref1;
        const selectUnSelect = isSelected ? "select all" : "unselect all";
        const selectedTab = tabList[activeTab] ? (ref = tabList[activeTab]) === null || ref === void 0 ? void 0 : (ref1 = ref.title) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase() : "";
        const selectedProducts = getSelectedProductsAnalyticName(tabData, true);
        const eventInfo = {
            clickInternalLinks: "true",
            eventAction: "my account:favorites:".concat(selectedTab, ":").concat(selectUnSelect),
            eventName: "my account:favorites:".concat(selectedTab, ":").concat(selectUnSelect),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: selectUnSelect,
            internalLinkPosition: "favorites",
            internalLinkType: "my account:" + selectedProducts,
            internalLinkURL: "n/a",
            internalLinkZoneName: "my account:favorites:".concat(selectedTab)
        };
        return JSON.stringify(eventInfo);
    };
    const addRemoveAnalyticsData = (type, removeOrCancel)=>{
        var ref, ref1;
        const removeOrCancelType = removeOrCancel || "remove";
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        const selectedTab = tabList[activeTab] ? (ref = tabList[activeTab]) === null || ref === void 0 ? void 0 : (ref1 = ref.title) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase() : "";
        const eventInfo = {
            eventAction: "my account:favorites:".concat(selectedTab, ":").concat(type ? type + ":" : "").concat(removeOrCancelType),
            eventName: "my account:favorites:".concat(selectedTab, ":").concat(type ? type + ":" : "").concat(removeOrCancelType),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: removeOrCancelType,
            internalLinkPosition: "favorites",
            internalLinkType: "my account:".concat(getSelectedProductsAnalyticName(selectedItems)),
            internalLinkZoneName: "my account:favorites:".concat(selectedTab).concat(type ? ":" + type : ""),
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        };
        window.adobeDataLayer.push({
            event: "cmp:click",
            eventInfo,
            page
        });
    };
    const removeClickHandler = ()=>{
        addRemoveAnalyticsData();
        if (enableRemove) openModal();
        else return;
    };
    const itemRemoveClickHandler = ()=>{
        addRemoveAnalyticsData("remove item modal", "yes remove item");
        handleDelete(closeModal);
    };
    const cancelRemoveItemClickHandler = ()=>{
        addRemoveAnalyticsData("remove item modal", "no keep item");
        closeModal();
    };
    if (isFavoritesLoading === "loading") {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AccountsLayout/* default */.Z, {
            title: isSaveProductToList ? staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.myLists : staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.favoriteTitle,
            user: user,
            activeTab: 0,
            i18n: staticTexts,
            data: data,
            redirect: redirect,
            logout: logout,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLoader/* default */.Z, {
                    loading: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderProgressiveLoading/* default */.Z, {})
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "favorites-container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountsLayout/* default */.Z, {
                    isListDetailsPage: isListDetailsPage,
                    activeTab: 1,
                    i18n: staticTexts,
                    isAuth: isAuth,
                    user: user,
                    logout: logout,
                    data: data,
                    redirect: redirect,
                    isSaveProductToList: isSaveProductToList,
                    createNewBtnText: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.createNewList,
                    createNewlist: createNewlist,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "favorites",
                        children: isFavoritesLoading === "loading" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Favorites_view_Loader, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: tabList && tabList.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_FavoriteNoResult, {
                                continueShopUrl: continueShopUrl,
                                authoredContent: authoredContent,
                                staticTexts: staticTexts,
                                ...restProps
                            }) : isSaveProductToList && activeTab === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MyList, {
                                siteName: siteName,
                                tabList: tabList,
                                presetConfigs: presetConfigs,
                                sorts: sorts,
                                tabChange: changeTab,
                                openCreateNewList: openCreateNewList,
                                createNewListCallBAck: setOpenCreateNewList,
                                query: props === null || props === void 0 ? void 0 : props.query,
                                setIsListDetailsPage: setIsListDetailsPage
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "favorites__header",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "container favorites__container",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    className: "favorites__title",
                                                    children: isSaveProductToList ? staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.myLists : title
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "favorites__tab-header",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    id: "fav-tab-panel",
                                                    className: "container favorites__tab-buttons",
                                                    role: "tablist",
                                                    ref: activeTabRef,
                                                    children: tabList === null || tabList === void 0 ? void 0 : tabList.map((tab, i)=>{
                                                        var ref, ref1, ref2, ref3;
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("button", {
                                                            id: "".concat(tab === null || tab === void 0 ? void 0 : tab.title, "-tab"),
                                                            "aria-label": (tab === null || tab === void 0 ? void 0 : tab.title) !== "All" ? tabs(tab === null || tab === void 0 ? void 0 : (ref = tab.data) === null || ref === void 0 ? void 0 : ref.length, tab === null || tab === void 0 ? void 0 : tab.title) : allTab,
                                                            "aria-selected": activeTab === i ? true : false,
                                                            role: "tab",
                                                            "data-gbh-data-layer": '{"eventAction":"my account:favorites:hero:menu","eventName":"my account:favorites:hero:menu","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"'.concat(tab.title, '","internalLinkPosition":"favorites","internalLinkType":"my account:navigation","internalLinkZoneName":"my account:favorites:hero","internalLinkURL":"n/a","clickInternalLinks":"true"}'),
                                                            className: "favorites__tab-button gbh-data-layer ".concat(activeTab === i ? "--active" : ""),
                                                            onClick: ()=>changeTab(i),
                                                            onFocus: ()=>changeTab(i),
                                                            onKeyDown: (e)=>handleKeyPress(e),
                                                            tabIndex: ((ref1 = tabList[activeTab]) === null || ref1 === void 0 ? void 0 : ref1.title) === (tab === null || tab === void 0 ? void 0 : tab.title) ? 0 : -1,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "tab-menu",
                                                                    children: tab === null || tab === void 0 ? void 0 : tab.title
                                                                }),
                                                                (tab === null || tab === void 0 ? void 0 : (ref2 = tab.data) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 && !isSaveProductToList ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "tab-item-count",
                                                                    children: (tab === null || tab === void 0 ? void 0 : tab.title) !== "All" ? "(".concat(tab === null || tab === void 0 ? void 0 : (ref3 = tab.data) === null || ref3 === void 0 ? void 0 : ref3.length, ")") : ""
                                                                }) : null
                                                            ]
                                                        }, i);
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "container favorites__container",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "row",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "favorites__favorite-controls ".concat(editMode ? "show-nav" : ""),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                id: "kf-fav-manage-btn",
                                                                role: "button",
                                                                "aria-label": manageText + " " + ariaManageText,
                                                                className: "favorites__manage-tools gbh-data-layer",
                                                                "data-gbh-data-layer": '{"eventAction":"my account:favorites:'.concat(tabList[activeTab] ? (ref = tabList[activeTab]) === null || ref === void 0 ? void 0 : ref.title : "n/a", ':manage","eventName":"my account:favorites:').concat(tabList[activeTab] ? (ref1 = tabList[activeTab]) === null || ref1 === void 0 ? void 0 : ref1.title : "n/a", ':manage","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"manage","internalLinkPosition":"favorites","internalLinkType":"my account:navigation","internalLinkZoneName":"my account:favorites:').concat(tabList[activeTab] ? (ref2 = tabList[activeTab]) === null || ref2 === void 0 ? void 0 : ref2.title : "n/a", '","internalLinkURL":"n/a","clickInternalLinks":"true"}'),
                                                                onClick: handleManageTool,
                                                                tabIndex: !editMode ? "0" : "-1",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        src: edit === null || edit === void 0 ? void 0 : edit.src,
                                                                        className: "manage-tools-icon",
                                                                        alt: "Manage tools"
                                                                    }),
                                                                    manageText
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
                                                                boundaryElement: ".favorites__container",
                                                                className: "favorites__sticky-nav-wrap ".concat(editMode ? "show-nav-wrap" : ""),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "container-fluid favorites__sticky-nav",
                                                                    group: manageFavorites,
                                                                    "aria-hidden": !editMode,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "row",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "col manage-strip-controls",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "manage-selected-items",
                                                                                    ref: manageSelected,
                                                                                    tabIndex: "-1",
                                                                                    "aria-label": ariaLabelManageSelected(selectedCount),
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            children: manageFavorites
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: "selected-count",
                                                                                            children: " (".concat(selectedCount, ")")
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "favorites__controls",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            role: "button",
                                                                                            tabIndex: editMode ? "0" : "-1",
                                                                                            "aria-label": selectedAll ? UnselectAll : selectAll,
                                                                                            className: "manage-menu-item gbh-data-layer",
                                                                                            "data-gbh-data-layer": getSelectUnSelectEventInfo(selectedAll, tabData),
                                                                                            onClick: ()=>{
                                                                                                return handleSelectAll(tabData === null || tabData === void 0 ? void 0 : tabData.map((i)=>{
                                                                                                    return i === null || i === void 0 ? void 0 : i.id;
                                                                                                }));
                                                                                            },
                                                                                            children: selectedAll ? UnselectAll : selectAll
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            "aria-disabled": !enableRemove,
                                                                                            role: "button",
                                                                                            tabIndex: editMode ? "0" : "-1",
                                                                                            "aria-label": ariaLabelRemove,
                                                                                            className: classnames_default()("manage-menu-item", !enableRemove && "manage-menu-item--disable-remove"),
                                                                                            onClick: removeClickHandler,
                                                                                            children: remove
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            role: "button",
                                                                                            className: "gbh-data-layer",
                                                                                            "data-gbh-data-layer": getEventInfo(),
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                                className: "favorites__close",
                                                                                                tabIndex: editMode ? "0" : "-1",
                                                                                                src: close_favorite === null || close_favorite === void 0 ? void 0 : close_favorite.src,
                                                                                                role: "presentation",
                                                                                                "aria-label": close,
                                                                                                onClick: handleManageTool,
                                                                                                alt: ""
                                                                                            })
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            role: "region",
                                                                                            "aria-live": "polite",
                                                                                            className: "aria-messages",
                                                                                            "aria-label": selectedAll ? staticTextsSelectedAll : ""
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Sort/* default */.Z, {
                                                                    tabIndex: !editMode ? "0" : "-1",
                                                                    page: "favorites",
                                                                    selectedtab: tabList[activeTab] ? (ref3 = tabList[activeTab]) === null || ref3 === void 0 ? void 0 : ref3.title : "",
                                                                    data: sorts,
                                                                    texts: staticTexts,
                                                                    onChange: handleSort,
                                                                    isOpen: isOpen,
                                                                    setIsOpen: setIsOpen,
                                                                    selectedSort: selectedSort,
                                                                    isMyFavoriteTab: true
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "row",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "favorites__tab-content",
                                                        role: "tabpanel",
                                                        id: "favorites-tab-panel",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "images-tab ".concat((ref4 = tabList[activeTab]) === null || ref4 === void 0 ? void 0 : ref4.title),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_masonry_css_module, {
                                                                breakpointCols: {
                                                                    default: 3,
                                                                    1200: 2
                                                                },
                                                                className: "my-masonry-grid",
                                                                columnClassName: "my-masonry-grid_column",
                                                                children: tabData === null || tabData === void 0 ? void 0 : tabData.map((item, i)=>{
                                                                    var ref;
                                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(react.Fragment, {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_FavoritesTile, {
                                                                            selectedtab: tabList[activeTab] ? (ref = tabList[activeTab]) === null || ref === void 0 ? void 0 : ref.title : "",
                                                                            index: i,
                                                                            fid: item === null || item === void 0 ? void 0 : item.id,
                                                                            data: item,
                                                                            locale: locale,
                                                                            editMode: editMode,
                                                                            onSelect: (fid)=>handleSelect(fid, tabData),
                                                                            isSelected: isSelected,
                                                                            selectedAll: selectedAll,
                                                                            isAuth: isAuth,
                                                                            user: user,
                                                                            staticTexts: staticTexts,
                                                                            swatchCount: swatchCount,
                                                                            presetConfigs: presetConfigs,
                                                                            smartCrop: smartCrop,
                                                                            brandSwitcherItems: brandSwitcherItems
                                                                        })
                                                                    }, i);
                                                                })
                                                            })
                                                        })
                                                    })
                                                })
                                            }),
                                            ((ref5 = tabList[activeTab]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.data) === null || ref6 === void 0 ? void 0 : ref6.length) > (tabData === null || tabData === void 0 ? void 0 : tabData.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "row",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    className: "favorites__load-more gbh-data-layer",
                                                    tabIndex: "0",
                                                    onClick: handleLoadMore,
                                                    "data-gbh-data-layer": '{"eventAction":"my account:favorites:'.concat(tabList[activeTab] ? tabList[activeTab].title : "", ':load more","eventName":"my account:favorites:').concat(tabList[activeTab] ? tabList[activeTab].title : "", ':load more","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"load more","internalLinkPosition":"favorites","internalLinkType":"my account:load more","internalLinkZoneName":"my account:favorites:').concat(tabList[activeTab] ? tabList[activeTab].title : "n/a", '","internalLinkURL":"n/a","clickInternalLinks":"true"}'),
                                                    children: loadMore
                                                })
                                            }),
                                            !props.favPage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "row",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "favorites__back-to-top",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsPerPage/* default */.Z, {
                                                            pos: "bottom",
                                                            curRows: rows,
                                                            selectedTab: tabList[activeTab] ? (ref7 = tabList[activeTab]) === null || ref7 === void 0 ? void 0 : ref7.title : "",
                                                            totalResults: (ref8 = tabList[activeTab]) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.data) === null || ref9 === void 0 ? void 0 : ref9.length,
                                                            page: "favorites",
                                                            data: productsPerPage,
                                                            texts: staticTexts,
                                                            onChange: handleRows
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                            role: "link",
                                                            "aria-label": staticTextsBackToTop,
                                                            className: "favorites__go-back gbh-data-layer",
                                                            "data-gbh-data-layer": '{"eventAction":"my account:favorites:'.concat(tabList[activeTab] ? tabList[activeTab].title : "", ':back to top","eventName":"my account:favorites:').concat(tabList[activeTab] ? tabList[activeTab].title : "", ':back to top","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"back to top","internalLinkPosition":"favorites","internalLinkType":"my account:back to top","internalLinkZoneName":"my account:favorites:').concat(tabList[activeTab] ? tabList[activeTab].title : "n/a", '","internalLinkURL":"n/a","clickInternalLinks":"true"}'),
                                                            onClick: handleBackToTop,
                                                            children: [
                                                                staticTextsBackToTop,
                                                                " ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: back_top_arrow/* default */.Z === null || back_top_arrow/* default */.Z === void 0 ? void 0 : back_top_arrow/* default.src */.Z.src,
                                                                    alt: staticTextsBackToTop
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "favorites-modal",
                    children: showModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal["default"], {
                        showModal: showModal,
                        onModalClose: ()=>setShowModal(false),
                        labelledBy: "favorites__modal-title",
                        describedBy: "favorites__modal-desc",
                        closeButtonAnalytics: getEventInfo("remove item modal"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "favorites__modal",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "favorites__modal-title",
                                    id: "favorites__modal-title",
                                    children: favoriteDeleteTitle
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "favorites__modal-desc",
                                    id: "favorites__modal-desc",
                                    children: favoritesDeleteMssg
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "favorites__modal-cta",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            role: "button",
                                            className: "gbh-data-layer",
                                            type: "ghost",
                                            label: itemCancel,
                                            onClick: cancelRemoveItemClickHandler
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            role: "button",
                                            type: "black",
                                            label: itemRemove,
                                            onClick: itemRemoveClickHandler
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
const Favorites_view_Loader = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "product-spinner",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product-spinner__image shimmer"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "product-spinner__content",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-spinner__title shimmer"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "product-spinner__desc",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "shimmer"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "shimmer"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "shimmer"
                            })
                        ]
                    })
                ]
            })
        ]
    });
/* harmony default export */ var Favorites_view = (FavoritesView);

// EXTERNAL MODULE: ./components/MyGenericFiller.jsx + 1 modules
var MyGenericFiller = __webpack_require__(41534);
;// CONCATENATED MODULE: ./components/MyFavorites/v1/MyFavorites.jsx





















const MyFavorites = (props)=>{
    const router = (0,next_router.useRouter)();
    const dispatch = (0,es/* useDispatch */.I0)();
    const { isAuth , user  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { fullFavoriteData: fav = {} , userLists =[] , status  } = (0,es/* useSelector */.v9)(favoritesSlice/* selectFavoritesState */.Qx);
    const { sortProducts: lineItems = [] , sortMedia: textLineItems = []  } = fav !== null && fav !== void 0 ? fav : {};
    const { data: componentProps = {} , header , siteName =""  } = props !== null && props !== void 0 ? props : {
        title: "",
        description: ""
    };
    const brandSwitcherItems = (0,utils/* getBrandSwitcher */.o4)(header);
    const { presetConfigs  } = componentProps;
    const [editMode, setEditMode] = (0,react.useState)(false);
    const [selectedItems, setSelectedItems] = (0,react.useState)([]);
    const [selectedAll, setSelectedALL] = (0,react.useState)(false);
    const [menuItems, setMenuItems] = (0,react.useState)([]);
    const [configData, setInitialConfigData] = (0,react.useState)({});
    const { toaster , featureFlags ={} , globalConfig: { internationalization: { locale ="" , language =""  } = {}  } = {}  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { MYSQLCONNSTR_ENABLE_SHOPPING_LISTS_V2: isSaveProductToList = false  } = featureFlags;
    const staticTexts = useMyfavoritesi18n({
        componentProps,
        selectedItems,
        isSaveProductToList
    });
    const [config, setInitialConfig] = (0,react.useState)({});
    const [loader, setLoader] = (0,react.useState)(true);
    const [tabListItm, setTabListItm] = (0,react.useState)([]);
    const selectedSortItem = (0,helper/* getSortItemBasedOnURL */.KE)(staticTexts, {
        name: "Featured"
    });
    const [toasterContent, setToasterContent] = (0,react.useState)({
        successMessage: "",
        unfavoriteSuccessMessage: ""
    });
    if (isSaveProductToList) {
        staticTexts.favorites = staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.myLists;
    }
    const setToasterMessage = (general)=>{
        if (!isEmpty_default()(toaster === null || toaster === void 0 ? void 0 : toaster.content)) {
            const { successMessage ="" , unfavoriteSuccessMessage =""  } = toaster.content;
            setToasterContent({
                successMessage: (0,helper/* getShortenedUrlwithGeneral */.vu1)(successMessage, general),
                unfavoriteSuccessMessage: (0,helper/* getShortenedUrlwithGeneral */.vu1)(unfavoriteSuccessMessage, general)
            });
        }
    };
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>{
            let locale = get_default()(config, "internationalization.locale", "");
            locale = locale === "fr-CA" ? "en-CA" : locale;
            const currencyCode = get_default()(config, "internationalization.currencyCode", "");
            const currencySign = get_default()(config, "internationalization.currencySign", "");
            const continueShopUrl = get_default()(config, "general.continueShopPath", "");
            setInitialConfigData({
                locale,
                currencyCode,
                currencySign,
                continueShopUrl
            });
            setInitialState(config);
            setToasterMessage(config === null || config === void 0 ? void 0 : config.general);
        });
        window.scrollTo({
            top: 1,
            behavior: "smooth"
        });
    }, []);
    (0,react.useEffect)(()=>{
        if (isSaveProductToList) return;
        const tabListData = [];
        const filterByType = (type)=>{
            return textLineItems === null || textLineItems === void 0 ? void 0 : textLineItems.filter((item)=>{
                var ref, ref1;
                return (item === null || item === void 0 ? void 0 : (ref = item.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.itemType) === type;
            });
        };
        if (lineItems.length || textLineItems.length) {
            var ref, ref1, ref2, ref3;
            if (lineItems === null || lineItems === void 0 ? void 0 : lineItems.length) {
                tabListData === null || tabListData === void 0 ? void 0 : tabListData.push({
                    title: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.productsTab,
                    data: lineItems
                });
            }
            if ((ref = filterByType("image")) === null || ref === void 0 ? void 0 : ref.length) {
                tabListData === null || tabListData === void 0 ? void 0 : tabListData.push({
                    title: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.imagesTab,
                    data: filterByType("image")
                });
            }
            if ((ref1 = filterByType("video")) === null || ref1 === void 0 ? void 0 : ref1.length) {
                tabListData === null || tabListData === void 0 ? void 0 : tabListData.push({
                    title: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.videosTab,
                    data: filterByType("video")
                });
            }
            if ((ref2 = filterByType("article")) === null || ref2 === void 0 ? void 0 : ref2.length) {
                tabListData === null || tabListData === void 0 ? void 0 : tabListData.push({
                    title: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.articlesTab,
                    data: filterByType("article")
                });
            }
            tabListData === null || tabListData === void 0 ? void 0 : tabListData.push({
                title: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.allTab,
                data: (ref3 = [
                    ...lineItems,
                    ...textLineItems
                ]) === null || ref3 === void 0 ? void 0 : ref3.sort((a, b)=>new Date(b.addedAt) - new Date(a.addedAt))
            });
        } else {
            setTabListItm([]);
        }
        if (tabListData.length) {
            setTabListItm(tabListData);
        }
    }, [
        lineItems === null || lineItems === void 0 ? void 0 : lineItems.length,
        textLineItems === null || textLineItems === void 0 ? void 0 : textLineItems.length,
        isSaveProductToList
    ]);
    (0,react.useEffect)(()=>{
        if (isSaveProductToList) {
            var ref;
            const tabListData = [];
            if (userLists.length) {
                tabListData === null || tabListData === void 0 ? void 0 : tabListData.push({
                    title: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.lists,
                    data: userLists
                });
            } else {
                tabListData === null || tabListData === void 0 ? void 0 : tabListData.push({
                    title: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.lists,
                    data: []
                });
            }
            const allItemsList = userLists === null || userLists === void 0 ? void 0 : userLists.filter((list)=>{
                return (list === null || list === void 0 ? void 0 : list.name[locale]) === "Favorites";
            });
            if (allItemsList.length && ((ref = allItemsList[0]) === null || ref === void 0 ? void 0 : ref.textLineItems.length)) {
                var ref1;
                var ref2;
                const textLineItems = (ref2 = (ref1 = allItemsList[0]) === null || ref1 === void 0 ? void 0 : ref1.textLineItems) !== null && ref2 !== void 0 ? ref2 : [];
                tabListData === null || tabListData === void 0 ? void 0 : tabListData.push({
                    title: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.media,
                    data: [
                        ...textLineItems
                    ].sort((a, b)=>new Date(b.addedAt) - new Date(a.addedAt))
                });
            }
            setTabListItm(tabListData);
        }
    }, [
        userLists
    ]);
    (0,react.useEffect)(()=>{
        if (isAuth) {
            dispatch((0,favoritesSlice/* getMyAccountFavorites */.w)()).unwrap().finally(()=>setLoader(false));
        }
    }, [
        isAuth,
        isSaveProductToList
    ]);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(config)) {
            const menuItemsList = (0,orders/* setMenu */.K0)(config, staticTexts, language, isSaveProductToList);
            if (isSaveProductToList) {
                menuItemsList.forEach((item)=>{
                    if ((item === null || item === void 0 ? void 0 : item.title) === (staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.favorites)) {
                        item.title = staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.myLists;
                    }
                });
            }
            setMenuItems(menuItemsList);
        }
    }, [
        config,
        isSaveProductToList
    ]);
    const setInitialState = async (config)=>{
        const accountSettingsPath = await (0,utils_location/* getShortenedUrl */.Pp)(get_default()(config, "general.accountSettingsPath", ""));
        const myFavoritesPagePath = await (0,utils_location/* getShortenedUrl */.Pp)(get_default()(config, "general.myFavoritesPagePath", ""));
        const orderHistoryPath = await (0,utils_location/* getShortenedUrl */.Pp)(get_default()(config, "general.orderHistoryPath", ""));
        const myProductsPath = await (0,utils_location/* getShortenedUrl */.Pp)(get_default()(config, "general.myProductsPath", ""));
        const myServicesPath = await (0,utils_location/* getShortenedUrl */.Pp)(get_default()(config, "general.myServicesPath", ""));
        const orderDetailsUrl = get_default()(config, "general.orderDetailsPath", "");
        const continueShopUrl = get_default()(config, "general.continueShopPath", "");
        const currencySign = get_default()(config, "internationalization.currencySign", "");
        setInitialConfig({
            accountSettingsPath,
            myFavoritesPagePath,
            orderHistoryPath,
            myProductsPath,
            myServicesPath,
            orderDetailsUrl,
            continueShopUrl,
            currencySign
        });
    };
    const handleEditMode = ()=>{
        setEditMode(!editMode);
    };
    const isSelected = (id)=>{
        return selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.includes(id);
    };
    const handleSelectToggle = (id, itemsList)=>{
        const isSelectedData = isSelected(id);
        const selectedItemsData = [
            ...selectedItems
        ];
        if (isSelectedData) {
            const newData = selectedItemsData === null || selectedItemsData === void 0 ? void 0 : selectedItemsData.filter((pid)=>pid !== id);
            setSelectedItems(newData);
            setSelectedALL(false);
            return;
        }
        const selectedAll = (selectedItemsData === null || selectedItemsData === void 0 ? void 0 : selectedItemsData.length) + 1 === (itemsList === null || itemsList === void 0 ? void 0 : itemsList.length);
        setSelectedItems([
            ...selectedItemsData,
            id
        ]);
        setSelectedALL(selectedAll);
    };
    const handleCheckAll = ()=>{
        setSelectedItems([]);
        setSelectedALL(false);
    };
    const handleSelectAll = (items)=>{
        if (selectedAll) {
            setSelectedItems([]);
            setSelectedALL(false);
        } else {
            setSelectedItems(items);
            setSelectedALL(true);
        }
    };
    const handleDelete = async (cb)=>{
        dispatch((0,favoritesSlice/* myAccountRemoveItems */.tC)(selectedItems)).unwrap().then(()=>{
            dispatch((0,genericSlice/* showToast */.CF)({
                message: toasterContent.unfavoriteSuccessMessage || staticTexts.removeItem,
                isVisible: true
            }));
            dispatch((0,favoritesSlice/* getMyAccountListsWithLineItems */.WQ)());
        });
        setSelectedItems([]);
        cb();
        (0,helper/* preventBodyScroll */.MVu)(false);
        window.scrollTo({
            top: 1,
            behavior: "smooth"
        });
    };
    const sorts = [
        {
            name: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.newToOld,
            query: "new"
        },
        {
            name: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.oldToNew,
            query: "old"
        }
    ];
    const signOut = ()=>{
        dispatch((0,authSlice/* logout */.kS)());
    };
    const redirect = (url)=>{
        router.replace(url).then(()=>{
            if (router === null || router === void 0 ? void 0 : router.asPath.includes(routes/* MY_LISTS_PAGE_PATH */.PN)) {
                dispatch((0,favoritesSlice/* getMyAccountListsWithLineItems */.WQ)());
            }
        });
    };
    if (loader) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MyGenericFiller/* default */.Z, {
            data: componentProps,
            title: isSaveProductToList ? "listTitle" : "favoriteTitle"
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Favorites_view, {
        loading: status,
        staticTexts: staticTexts,
        tabList: tabListItm,
        productsPerPage: constants.PRODUCTS_PER_PAGE,
        sorts: sorts,
        handleDelete: handleDelete,
        editMode: editMode,
        handleEditMode: handleEditMode,
        locale: configData === null || configData === void 0 ? void 0 : configData.locale,
        handleSelect: handleSelectToggle,
        handleSelectAll: handleSelectAll,
        selectedAll: selectedAll,
        isSelected: isSelected,
        selectedCount: selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.length,
        authoredContent: componentProps,
        continueShopUrl: configData === null || configData === void 0 ? void 0 : configData.continueShopUrl,
        user: user,
        isAuth: isAuth,
        selectedItems: selectedItems,
        handleCheckAll: handleCheckAll,
        isFavoritesLoading: status,
        presetConfigs: presetConfigs,
        data: menuItems,
        logout: signOut,
        redirect: redirect,
        selectedSortItem: selectedSortItem,
        favPage: true,
        brandSwitcherItems: brandSwitcherItems,
        isSaveProductToList: isSaveProductToList,
        siteName: siteName,
        query: props === null || props === void 0 ? void 0 : props.query
    });
};
/* harmony default export */ var v1_MyFavorites = (MyFavorites);

// EXTERNAL MODULE: ./hooks/usePageAuth.js
var usePageAuth = __webpack_require__(48375);
// EXTERNAL MODULE: ./components/Shared/GlobalPage/GlobalPageHeader.jsx
var GlobalPageHeader = __webpack_require__(81169);
// EXTERNAL MODULE: ./components/Shared/GlobalPage/GlobalPageFooter.jsx
var GlobalPageFooter = __webpack_require__(10884);
// EXTERNAL MODULE: ./components/AemGrid.jsx + 192 modules
var AemGrid = __webpack_require__(64799);
// EXTERNAL MODULE: ./components/Shared/UpsellInstallServices/index.jsx + 1 modules
var UpsellInstallServices = __webpack_require__(61054);
;// CONCATENATED MODULE: ./pages/my-account/[...slug].jsx












const MyFavoritesPage = (param)=>{
    let { tmpData: data = {} , headertmp: header = {} , footertmp: footer = {} , globalScript , footerScript , analysticsScript , analyticsData ={} , datalayerPageName ="" , gbhDataLayerCustom ={} , siteName ="" , query ={}  } = param;
    const dispatch = (0,es/* useDispatch */.I0)();
    (0,usePageAuth/* default */.Z)();
    (0,react.useEffect)(()=>{
        (0,helper/* getDataLayerObj */.C2G)(analyticsData);
    }, [
        analyticsData
    ]);
    (0,react.useEffect)(()=>{
        dispatch((0,genericSlice/* setDatalayerPageName */.dN)(datalayerPageName));
        dispatch((0,genericSlice/* setGbhDataLayerCustom */.ks)(gbhDataLayerCustom));
        return ()=>{
            dispatch((0,genericSlice/* setDatalayerPageName */.dN)(""));
            dispatch((0,genericSlice/* setGbhDataLayerCustom */.ks)(""));
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPageHeader/* default */.Z, {
                header: header,
                title: data.title,
                globalScripting: globalScript,
                analysticsScript: analysticsScript
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AemGrid/* default */.Z, {
                data: data,
                count: 0,
                myFavorites: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(v1_MyFavorites, {
                        data: data,
                        header: header,
                        siteName: siteName,
                        query: query
                    }),
                myGenericFiller: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(MyGenericFiller/* default */.Z, {
                        data: data,
                        title: "listTitle"
                    }),
                upSellContainer: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(UpsellInstallServices/* default */.Z, {
                        authData: data
                    })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPageFooter/* default */.Z, {
                footer: footer,
                footerScripting: footerScript
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var _slug_ = (MyFavoritesPage);


/***/ }),

/***/ 25443:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"LoaderComponent":"Loader_LoaderComponent__IQYdb"};

/***/ }),

/***/ 84267:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ListDetailsWrapper":"MyList_ListDetailsWrapper__0qwmH"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3147,1054,1466,8787,3893,9774,2888,179], function() { return __webpack_exec__(75563); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);